import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import {
    TextField,
    Grid,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Button,
    InputAdornment,
    IconButton,
    Typography,
    Box,
    Stack,
    Modal,
    Divider,
    SvgIcon,
    Autocomplete,
    Switch,
    CircularProgress,
    TextareaAutosize,
    Tooltip,
    Menu,
    Checkbox,
    FormControlLabel
} from "@mui/material";
// import { Editor } from 'react-draft-wysiwyg';
// import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { LoadingButton } from "@mui/lab";
import { KeyboardBackspace, KeyboardArrowLeft, KeyboardArrowRight, SettingsPowerTwoTone, AlignHorizontalCenter, Widgets } from "@mui/icons-material";
import ReactQuill from "react-quill";
import { makeStyles } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Header from "../../components/headers/Header";
import demoImage from "../../assets/image1.png";
import { Edit } from "@mui/icons-material";
import { Download } from "@mui/icons-material";
import { Share } from "@mui/icons-material";
import { Delete } from "@mui/icons-material";
import { ThumbUp } from "@mui/icons-material";
import { ThumbDown } from "@mui/icons-material";
import { ReactComponent as EyeIcon } from "../../assets/ico_eye.svg";
import { Link, Navigate } from "react-router-dom";
import { isMobile, useDeviceData, isBrowser } from "react-device-detect";
import {
    useGeneratedbusinessurlblogsMutation, useGetBlogDetQuery, useDeleteClipMutation,
    useBlogDetailsPublishMutation, useSavingThumbsUpMutation, useSavingThumbsDownMutation,
    useBlogDetailsDraftMutation, useRegenerateBusinessBlogMutation, useBlogsCountQuery, useCampaignBlogsCountQuery,
    useCopyurlMutation, usePublishtogoogleMutation, usePublishUnpublishCountMutation, useGetBlogsByCampaignstatusQuery,
    useGetGeneratedClipsListingsMutation, useClipsListingsCountQuery, useDeleteMultipleClipsMutation,
} from "../../redux/api/promptApi";
import { IGetBlogsAdmin, IgeneratedbusinessblogDet } from "../../redux/api/types";
import { useLazyGetProductQuery } from '../../redux/api/productApi';
import { useNavigate, useLocation } from "react-router-dom";
import PayNowButton from '../payment/payNowButton';
import { object, string, TypeOf, number } from "zod";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './clips_section.css';
import { ReactComponent as DownloadIcon } from "../../assets/download_ico.svg";
import { ReactComponent as ShareIcon } from '../../assets/share_ico.svg';
import { ReactComponent as TrashIcon } from '../../assets/trash_ico.svg';
import { ReactComponent as EditIcon } from '../../assets/pencil_ico.svg';
import { ReactComponent as LikeIcon } from '../../assets/like_ico.svg';
import { ReactComponent as DisLikeIcon } from '../../assets/dislike_ico.svg';
import { ReactComponent as ViewIcon } from '../../assets/view1_ico.svg';
import { ReactComponent as RegenerateIcon } from '../../assets/regenerate_ico.svg';
import { useGetgeneratedBlogListingsQuery } from '../../redux/api/promptApi';
import { useGetproductsDetQuery } from '../../redux/api/promptApi';
import { ReactComponent as MenuIcon } from '../../assets/Menu_ico.svg';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useGetUserDetailsMutation } from "../../redux/api/authApi";
import { renderToStaticMarkup } from 'react-dom/server';
import { ReactComponent as FeedBackIcon } from '../../assets/ico_feedback.svg'
import { useFeedBackMutation } from '../../redux/api/authApi';
import { store, useAppDispatch, useAppSelector } from "../../redux/store";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { IPlanDetail } from "../../redux/api/types";
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import {
    useCampaignListMutation, useGetCnameEntriesMutation, useGetBlogsByCampaignQuery,
    useGetBlogGenerationStatusMutation, useGetGeneratedClipsListingsSearchMutation
} from "../../redux/api/promptApi";
import { usePlanDetailsMutation } from "../../redux/api/productApi";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Pagination from "@mui/material/Pagination";
import youtubeIco1 from '../../assets/traffic_monster/youtubeIco_1.png'
import unsplashImg from '../../assets/traffic_monster/unsplash_ico_logo.png';
// import Stack from "@mui/material";
import unsplash_logo from '../../assets/traffic_monster/unsplash_logo.png';
import CloseIcon from '@mui/icons-material/Close';
import DraftBtn from '../../assets/traffic_monster/draftBtn.png';
// import EditNoteIcon from '@mui/icons-material/EditNote';
import { ReactComponent as ExportIcon } from '../../assets/podcast_monster/export_ico.svg';
import CodeIcon from '@mui/icons-material/Code';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ClipboardIcon from '@mui/icons-material/FileCopy';
import { ReactComponent as WordIcon } from '../../assets/podcast_monster/docx_ico.svg';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ReactComponent as ToggleIcon } from '../../assets/podcast_monster/toggle.svg';
import { ReactComponent as WPLogoWhite } from '../../assets/podcast_monster/wordpressLogo_white.svg';
import { ReactComponent as MediumLogo } from '../../assets/podcast_monster/mediumLogo.svg';
import { ReactComponent as PlayBtn } from '../../assets/podcast_monster/play_btn.svg';
import { ReactComponent as WPLogoBlue } from '../../assets/podcast_monster/wordpressLogo_blue.svg';
import bloggerLogo from '../../assets/podcast_monster/blogger_logo.png';
import ghostLogo from '../../assets/podcast_monster/ghost_logo.png';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { debug } from "console";
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { ReactComponent as SaveIcon } from '../../assets/podcast_monster/save_ico.svg';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import MicIcon from '@mui/icons-material/Mic';
import transcript_img from '../../assets/podcast_monster/transcript_img.png';
import SettingsIcon from '@mui/icons-material/Settings';
import { getCookie } from "utils/storageUtils";
import best_1 from '../../assets/ocesha_images/best_1.png';
import { ReactComponent as NotePencilIco } from '../../assets/ocesha_images/note_pencil_ico.svg';
import { ReactComponent as DeletIcon } from '../../assets/ocesha_images/delete_ico.svg';
import { ReactComponent as SubMenuIcon } from '../../assets/ocesha_images/sub_menu_ico.svg';
import { ReactComponent as TrashIco } from '../../assets/ocesha_images/trash_ico.svg';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { ReactComponent as EditIco } from '../../assets/ocesha_images/edit_ico.svg';
import { ReactComponent as ViewIco } from '../../assets/ocesha_images/view_ico.svg';
import { ReactComponent as ExportIco } from '../../assets/ocesha_images/export_ico.svg';
import { ReactComponent as VideioIco } from '../../assets/ocesha_images/video_ico.svg';
import { ReactComponent as ImageIco } from '../../assets/ocesha_images/images_ico.svg';
import { ReactComponent as ClipIco } from '../../assets/ocesha_images/clip_ico.svg';
import { ReactComponent as DeleteIco } from '../../assets/ocesha_images/delete_icon.svg';
import { ReactComponent as RegenerateIco } from '../../assets/ocesha_images/regenerate_ico.svg';
import { ReactComponent as SettingsIco } from '../../assets/ocesha_images/settings_ico.svg';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import youtubeIco from '../../assets/traffic_monster/youtubeIco_1.png';
import ProgressBar from "@ramonak/react-progress-bar";
import PublishIcon from '@mui/icons-material/Publish';
import { ReactComponent as UploadIcon } from '../../assets/upload_.svg';
import { ReactComponent as WPconfigIcon } from '../../assets/configure_.svg';
// NEW: Icons for the 4-icon action row (matching blogs_section)
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CheckIcon from "@mui/icons-material/Check";

interface Blog {
    id: string;
    image_updated: 'Yes' | 'No';
    // Add other properties as needed
}

const customInputStyle = {
    color: '#fff',
    border: '1px solid #CBCBCB',
};

let timestampInMilliseconds = Date.now();
let milliSeconds = Math.floor(timestampInMilliseconds / 1000);


const feedbackform = object({
    email: string(),
    rating: number(),
    feedback: string(),
    productname: string(),
    date: string()
});

const blogUpdate = object({
    id: string(),
    blog_title: string(),
    blog_image_string: string(),
    blog_summary: string(),
    blog_det: string(),
    url: string(),
    publish_date: string(),
    author: string(),
    author_image: string(),
    author_url: string(),
    cta_label: string(),
    cta_url: string(),
    blog_image_path: string(),
    videotag: string(),
    product_id: string()
})

export type FeedBackForm = TypeOf<typeof feedbackform>

export type BlogUpdate = TypeOf<typeof blogUpdate>

const blogDraft = object({
    id: string(),
    blog_title: string(),
    blog_image_string: string(),
    blog_image: string(),
    blog_summary: string(),
    blog_det: string(),
    url: string(),
    author: string(),
    author_image: string(),
    author_url: string(),
    cta_label: string(),
    cta_url: string()
})

export type BlogDraft = TypeOf<typeof blogDraft>

interface LoadingStates {
    [key: string]: boolean;
}

const baseUrl = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/`;

//test comment to fource merge
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: '#1377C3', 
        backgroundColor: '#0F74BF',
        color: 'lightblack',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        // backgroundColor: 'white',
        /* backgroundColor: '#131825', */ // Set background color for odd rows to white
        color: 'black', // Set text color for odd rows to black
    },
    '&:nth-of-type(even)': {
        // backgroundColor: '#F2F6FA',
        /* backgroundColor: '#131825', */ // Set background color for even rows to gray
        color: 'darkslategray',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

interface UnsplashImage {
    id: string;
    urls: {
        thumb: string;
        regular: string;
    };
    alt_description: string;
    width: number;
    height: number;
}


/* loading over lay part starts */
const COPY_OVERLAY_ID = "tm-copy-overlay";

const showCopyOverlay = (label = "Processing…") => {
    if (document.getElementById(COPY_OVERLAY_ID)) return;

    const container = document.createElement("div");
    container.id = COPY_OVERLAY_ID;
    Object.assign(container.style, {
        position: "fixed",
        inset: "0",
        zIndex: "2000",
        display: "grid",
        placeItems: "center",
        backdropFilter: "blur(3px)",
        background: "rgba(0,0,0,0.45)",
    });

    const card = document.createElement("div");
    Object.assign(card.style, {
        padding: "16px 24px",
        borderRadius: "12px",
        background: "#161b22",
        color: "#e5e7eb",
        fontWeight: "600",
        fontSize: "14px",
        display: "inline-flex",
        alignItems: "center",
        gap: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
    });

    const spinner = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    spinner.setAttribute("viewBox", "0 0 24 24");
    spinner.setAttribute("width", "28");
    spinner.setAttribute("height", "28");
    spinner.innerHTML = `
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" stroke-opacity="0.25" fill="none"></circle>
    <path d="M4 12a8 8 0 0 1 8-8" stroke="currentColor" stroke-width="4" stroke-linecap="round" fill="none"></path>
  `;
    spinner.style.animation = "tmCopySpin 0.9s linear infinite";
    spinner.style.color = "#1976d2";

    const text = document.createElement("span");
    text.textContent = label;

    const styleTag = document.createElement("style");
    styleTag.textContent = `@keyframes tmCopySpin { to { transform: rotate(360deg); } }`;

    card.appendChild(spinner);
    card.appendChild(text);
    container.appendChild(card);
    container.appendChild(styleTag);

    document.body.appendChild(container);
};

const hideCopyOverlay = () => {
    const node = document.getElementById(COPY_OVERLAY_ID);
    if (node) document.body.removeChild(node);
};

const Clips_Section = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { FromCampaign } = location.state || {};
    const { FromUpdatedCampaign } = location.state || {};
    const { FromDashboard, ...otherState } = location.state || {};
    const { subscription } = location.state || {};
    const { userEmail } = location.state || {};
    const { AuthorizedWordpress } = location.state || {};
    const [selected, setSelected] = useState(false);
    const [openEdit, setOPenEdit] = useState(false);
    const [openPaidModal, setOpenPaidModal] = useState(false);
    const [helperModal, setHelperModal] = useState(FromDashboard === 'true' ? true : localStorage.getItem('AlertMessage') === 'false' ? false : false);
    const [isLiked, setIsLiked] = useState('');
    const [isDisLiked, setIsDisLiked] = useState('');
    //feedback popup
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const ratings = [1, 2, 3, 4, 5];
    const user = useAppSelector((state) => state.userState.user);
    const [productName, setProductName] = useState<string | null>(localStorage.getItem('module'));
    const currentDate = new Date().toISOString();
    const [feedbackForm, setFeedbackForm] = useState<FeedBackForm>({ email: localStorage.getItem('user_email') || "", rating: 0, feedback: '', productname: productName || '', date: currentDate })
    const [feedbackMutation] = useFeedBackMutation();

    const [getProduct, getProductState] = useLazyGetProductQuery();
    const genieSelector = useAppSelector((state) => state.genieState);
    const [wishRemCount, setWishRemCount] = useState(0);
    const [isTranscribeEditable, setIsTranscribeEditable] = useState<boolean>(false);


    const [generatedBlogDetail, setGeneratedBlogDetail] = useState<any>();
    const [generatedBlogDetailSearch, setGeneratedBlogDetailSearch] = useState<any>();

    const [updatingTranscription, setUpdatingTranscription] = useState<boolean>(false);

    const [generatedClipsDetail, setGeneratedClipsDetail] = useState<any>();
    const [productDetail, setProductDetail] = useState<any>();
    const [productURL, setProductURL] = useState('');
    const [planDetails, setPlanDetails] = useState<any>();
    const [timestampInSeconds, setMilliSeconds] = useState(0);
    const [freePlann, setFreePlan] = useState(localStorage.getItem('free_plan'));
    const [subscriptionLevel, setSubscriptionLevel] = useState(localStorage.getItem('subscription_level'));
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [searchstr, setSearchstr] = useState('');

    const staticTypeOptions = ['Blogs']
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, false] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],  // Include alignment options
        ],
    };

    const [getGeneratedClipsListingsMutation] = useGetGeneratedClipsListingsMutation();
    const [getGeneratedClipsListingsSearchMutation] = useGetGeneratedClipsListingsSearchMutation();

    const [regenerateBusinessBlogMutation] = useRegenerateBusinessBlogMutation();
    const [publishUnpublishCountMutation] = usePublishUnpublishCountMutation();

    const [publishedUnpublishedCount, setPublishedUnpublishedCount] = useState<any>();
    const [userDets, setUserDets] = useState<any>();
    const [getUserDetailsMutation] = useGetUserDetailsMutation();

    const user_email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : userEmail ? userEmail : getCookie('user_email') ? getCookie('user_email') : '';

    // const blogGenerated = localStorage.getItem('Blogs Generated');

    const [selectedBlogIndex, setSelectedBlogIndex] = useState(0);

    const [isLoading, setIsLoading] = useState<LoadingStates>({});

    const [isLoadingTranscript, setIsLoadingTranscript] = useState<LoadingStates>({});

    const [isLoadingCopied, setIsLoadingCopied] = useState<LoadingStates>({});

    // NEW: per-clip publish loading state
    const [isPublishLoading, setIsPublishLoading] = useState<LoadingStates>({});
    const [currentBlogForPublish, setCurrentBlogForPublish] = useState<any>(null);

    const [selectedBlogTitle, setSelectedBlogTitle] = useState('');

    const [searchQuery, setSearchQuery] = useState('');
    const searchTerm = searchQuery.trim();

    const [updateblogs, setUpdateBlogs] = useState<BlogUpdate>({ id: '', blog_title: '', blog_image_path: '', blog_image_string: '', blog_summary: '', blog_det: '', url: '', publish_date: '', author: '', author_image: '', author_url: '', cta_label: '', cta_url: '', videotag: '', product_id: '' });

    const [selectedBlog, setSelectedBlog] = useState<IgeneratedbusinessblogDet | null>(null);

    const [prevImgLoader, setPrevImgLoader] = useState<boolean>(false);

    const [deleteClipMutation] = useDeleteClipMutation();

    const [savingthumbsupMutation] = useSavingThumbsUpMutation();

    const [savingthumbsdownMutation] = useSavingThumbsDownMutation();

    const [blogDetailsDraftMutation] = useBlogDetailsDraftMutation();
    const [blogDetailsPublishMutation] = useBlogDetailsPublishMutation();
    const [copySharingUrlMutation] = useCopyurlMutation();
    const [publishtogoogleMutation] = usePublishtogoogleMutation();
    const [searchResults, setSearchResults] = useState([]);
    const [authUrl, setAuthUrl] = useState('');
    const [blogImg, setBlogImg] = useState('');
    const [authorImg, setAuthorImg] = useState('');
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [authorImgFile, setAuthorImgFile] = useState<File | null>(null);
    const [isDraftOrPublishLoading, setIsDraftOrPublishLoading] = useState<boolean>(false);
    const [isMenuDropdownOpen, setIsMenuDropdownOpen] = useState<any>();
    //const [varImageUpdated, setVarImageUpdated] = useState<boolean>(false);
    const [openExportModal, setOpenExportModal] = useState(false);
    const [blogIdForExport, setBlogIdForExport] = useState<any>();
    const [urlForExport, setUrlForExport] = useState<any>();
    const [blogDetForExport, setBlogDetForExport] = useState<any>();
    const [imageForExport, setImageForExport] = useState<any>();
    const [productIdForExport, setproductIdForExport] = useState<any>();
    const [titleForExport, setTitleForExport] = useState<any>();
    const [summaryForExport, setSummaryForExport] = useState<any>();
    const [isDownloadLoading, setIsDownloadLoading] = useState<any>();
    const [isLoadingShareLink, setIsLoadingShareLink] = useState<string | null>(null);
    const [isLoadingEditPost, setIsLoadingEditPost] = useState<string | null>(null);
    const submenuRef = useRef<HTMLDivElement | null>(null);

    let varImageUpdated = false;

    const [getuserPlanDetails] = usePlanDetailsMutation();
    const [openUnsplash, setOpenUnsplash] = useState<any>();
    const [selectedUnsplashImg, setSelectedUnsplashImg] = useState(null);
    const [helpervideosrc, setHelperVideoSrc] = useState<any>();
    const [helperPopup, setHelperPopup] = useState<boolean>(false);
    const [sharingpostdata, setSharingPostData] = useState<any>();
    const [openPostEdit, setOpenPostEdit] = useState<boolean>(false);
    const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
    const [deteleModal, setDeleteModal] = useState<boolean>(false);
    const [transcriptModal, setTranscriptModal] = useState<boolean>(false);
    const [mediaModal, setMediaModal] = useState<boolean>(false);
    const [mediaUrl, setMediaUrl] = useState<string | null>(null);
    const [mediaType, setMediaType] = useState<"video" | "audio">("video");
    const [wordpressModal, setWordpressModal] = useState<boolean>(false);
    const [transcribedData, setTranscribedData] = useState<any>();
    const [deleteBlogId, setDeleteBlogId] = useState<any>();
    const [anchorEl, setAnchorEl] = useState(null);
    const [blogIdofsubmenu, setBlogidofsubmenu] = useState<any>();
    const [productIdofsubmenu, setProductIdofSubmenu] = useState<any>();
    const [publishBlogModal, setPublishBlogModal] = useState<boolean>(false);
    const [publishToOcesha, setPublishToOcesha] = useState<any>(false);
    const [publishToCodegenie, setPublishToCodegenie] = useState<any>(false);
    const [blogIdToPublish, setBlogIdToPublish] = useState<any>();
    const [selectedDate, setSelectedDate] = useState<any>(null);
    const [closeDateFilter, setCloseDateFilter] = useState<boolean>(false);
    const [openMenuId, setOpenMenuId] = useState(null);
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);
    const [toUpgrade, setToUpgrade] = useState<boolean>(false);
    const [loaderProgress, setLoaderProgress] = useState<any>(4);
    const [loadingBlog, setLoadingBlog] = useState<boolean>(false);
    const [intervaltime, setIntervalTime] = useState(2000);

    const [wpUrl, setWpUrl] = useState('');
    const [wpUsername, setWpUsername] = useState('');
    const [wpPassword, setWpPassword] = useState('');
    const [wploading, setWpLoading] = useState(false);

    const [shareAnchorEl, setShareAnchorEl] = useState<HTMLElement | null>(null);

    //latest
    const CLIENT_ID = process.env.REACT_WP_APP_CLIENT_ID || '119972';
    const REDIRECT_URI = process.env.REACT_WP_APP_REDIRECT_URI || 'https://podcastclip.ocesha.com/callback';
    const [wpAccessToken, setWpAccessToken] = useState('');
    const [wpSite, setWpSite] = useState('');
    const wpTriggered = useRef(false);
    const [publishSuccessModal, setPublishSuccessModal] = useState<boolean>(false);

    const [selectedClipIds, setSelectedClipIds] = useState<string[]>([]);
    const [deleteMultipleClipsMutation] = useDeleteMultipleClipsMutation();
    const [isBulkPublishing, setIsBulkPublishing] = useState(false);
    const [bulkDeleteModal, setBulkDeleteModal] = useState(false);

    const [editingDescriptionId, setEditingDescriptionId] = useState<string | null>(null);
    const [editedDescription, setEditedDescription] = useState("");

    const [editingTitleId, setEditingTitleId] = useState<string | null>(null);
    const [editedTitle, setEditedTitle] = useState("");
    //
    // const videoRef = useRef<HTMLVideoElement>(null);

    /* const handlePlayVideo = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    }; */
    const handlePlayVideo = (videoSrc: any) => {
        // window.open('/images/wordpress.mp4', '_blank');
        //setHelperVideoSrc(videoSrc);
        //setHelperPopup(true);
    }
    const handlePlayVideo1 = (videoSrc: any) => {
        // window.open('/images/medium.mp4', '_blank');
        setHelperVideoSrc(videoSrc);
        setHelperPopup(true);
    }

    const handlePlayVideo2 = (videoSrc: any) => {
        // window.open('/images/blogger.mp4', '_blank');
        setHelperVideoSrc(videoSrc);
        setHelperPopup(true);
    }

    const handlePlayVideo3 = (videoSrc: any) => {
        // window.open('/images/ghost.mp4', '_blank');
        setHelperVideoSrc(videoSrc);
        setHelperPopup(true);
    }

    useEffect(() => {
        const loggedIn = localStorage.getItem("logged_in");
        if (loggedIn !== "true") {
            navigate("/signin");
        }
    }, [navigate]);


    const [plans, setPlans] = useState<IPlanDetail[]>([
        {
            user: 1,
            plan_name: "",
            total_wishes: 0,
            price: "",
            period: "",
            product_id: "",
            price_id: "",
            subscription_level: "",
            feature: [],
            contracts: 0,
            type: "",
            button_text: "",
            save: ''
        },
    ]);

    useEffect(() => {
        if (userEmail) {
            localStorage.setItem('user_email', userEmail || getCookie('user_email'));
        }
    }, [userEmail]);
    const fetchPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({ email: user_email, campaignid: ''/* selectedCampaign */ });

            if ('data' in response) {
                setPlanDetails(response.data.data);
                // console.log('plan details=>', planDetails.data);
            }
        } catch (error) {
            //console.log(error);
        }
    }

    useEffect(() => {
        if (helperModal) {
            localStorage.setItem('AlertMessage', "true");
        } else if (!FromDashboard) {
            localStorage.setItem('AlertMessage', "false");
        }
        setMilliSeconds(milliSeconds);
    });

    useEffect(() => {
        fetchPlanDatas();
        //console.log('plan detsss=>', planDetails);
    }, [/* planDetails */]);

    useEffect(() => {
        // Update the name state when userDetails changes
        if (userDets)
            setAuthUrl(userDets.social_url);
    }, [userDets]);

    const handleBlogSelect = (index: any) => {
        setSelectedBlogIndex(index);
    }
    // const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromText(updateblogs.blog_det)));

    // handler that both updates state and triggers fetch
    const handlePageChange = async (_: React.ChangeEvent<unknown> | null, value: number) => {
        setCurrentPage(value);
        const skip = (value - 1) * pageSize;

        try {
            //setLoading(true);
            await fetchClipsData(pageSize, skip, searchTerm, fromDate, toDate); // fetchData(limit, skip) should exist (useCallback)
        } catch (err) {
            console.error("Pagination fetch error:", err);
        } finally {
            //setLoading(false);
        }
    };


    const handleClipsSearch = async (_event: unknown, rawValue: string, reason?: string) => {
        const value = rawValue ?? "";

        if (reason === "reset") {
            return;
        }

        setSearchQuery(value);

        const trimmedValue = value.trim();
        if (!trimmedValue || reason === "clear") {
            setGeneratedBlogDetailSearch([]);
            return;
        }

        try {
            await fetchClipsDataSearch(trimmedValue);
        } catch (err) {
            console.error("Clips search error:", err);
        }
    };

    const fetchClipsData = async (
        limitvalarg: number = 12,
        skipvalarg: number = 0,
        searchstrarg?: string,
        fromDateArg?: string | null,
        toDateArg?: string | null
    ) => {
        //if (FromDashboard || fromDate || toDate || (closeDateFilter === true)) {
        try {
            const effectiveSearch = searchstrarg !== undefined ? searchstrarg : searchTerm;
            const effectiveFromDate = fromDateArg !== undefined ? fromDateArg : fromDate;
            const effectiveToDate = toDateArg !== undefined ? toDateArg : toDate;
            showCopyOverlay();
            const podcastId = localStorage.getItem('podcastId');
            const response = await getGeneratedClipsListingsMutation({
                email: user_email,
                product_id: podcastId ?? '',
                limitval: limitvalarg,
                skipval: skipvalarg,
                search: effectiveSearch,
                fromDate: effectiveFromDate ?? undefined,
                toDate: effectiveToDate ?? undefined
            });
            if ('data' in response) {
                const { data } = response;
                setGeneratedBlogDetail(data);
                hideCopyOverlay();
                console.log('data from variable=>', data);
            } else if ('error' in response) {
                hideCopyOverlay();
                const { error } = response;
                //console.log('Error:', error);
            }
        } catch (error) {
            hideCopyOverlay();
            //console.error('Error fetching blogs:', error);
        }
        //}
    };

    useEffect(() => {
        setCurrentPage(1);
        fetchClipsData(pageSize, 0, undefined, fromDate, toDate);
    }, [FromDashboard, getGeneratedClipsListingsMutation, user_email, timestampInSeconds, fromDate, toDate]);



    const fetchClipsDataSearch = async (searchstrarg: string = "") => {
        const podcastId = localStorage.getItem('podcastId');
        //if (FromDashboard || fromDate || toDate || (closeDateFilter === true)) {
        try {
            const response = await getGeneratedClipsListingsSearchMutation({ email: user_email, product_id: podcastId ?? '', search: searchstrarg });
            if ('data' in response) {
                const { data } = response;
                const result = Array.isArray(data) ? data : [];
                setGeneratedBlogDetailSearch(result);

                //console.log('data from variable=>', data);
                return result;
            } else if ('error' in response) {

                const { error } = response;
                //console.log('Error:', error);
                setGeneratedBlogDetailSearch([]);
            }
        } catch (error) {
            //console.error('Error fetching blogs:', error);
            setGeneratedBlogDetailSearch([]);
        }
        //}
        return [];
    };



    useEffect(() => {
        if (localStorage.getItem('FromEditBlog') === 'true') {
            localStorage.setItem('FromEditBlog', 'false');
            localStorage.setItem('activeItem', 'clips');
            window.location.reload();
        }
    }, []);


    // // handler that both updates state and triggers fetch
    // const fetchEpisodeData = async (_: React.ChangeEvent<unknown> | null, value: number) => {
    //     setCurrentPage(value);
    //     const skip = (value - 1) * pageSize;

    //     try {
    //         //setLoading(true);
    //         await fetchImgData(pageSize, skip); // fetchData(limit, skip) should exist (useCallback)
    //     } catch (err) {
    //         console.error("Pagination fetch error:", err);
    //     } finally {
    //         //setLoading(false);
    //     }
    // };

    const generatingCount = parseInt(localStorage.getItem('Generating Count') || '0') >= 1;
    const freePlan = parseInt(localStorage.getItem('free_plan') || '0') === 0;

    useEffect(() => {
        if (getBlogsCount?.data > 0) {
            localStorage.setItem('blogsCount', 'true');
        } else {
            localStorage.setItem('blogsCount', 'false');
        }
    })

    useEffect(() => {
        if (generatingCount) {
            localStorage.setItem("free_plan", "0");
        }
    })

    const handleRegenerateBlogClick = () => {
        if (generatingCount) {
            localStorage.setItem("free_plan", "0");
            navigate('/codegenie/dashboard');
        }
        /* if (freePlan) {
            setOpenPaidModal(true);
        } */ /* else {
            navigate('/codegenie/dashboard');
        } */
    }

    const handleFormSubmit = () => {
        // Call the feedbackMutation function with the form data as payload
        feedbackMutation(feedbackForm)
            .then((response) => {
                // console.log('Feedback sent successfully:', response);
                toast.success('FeedBack Sent Successfully!!');
                setIsPopupOpen(false);
                setFeedbackForm({
                    email: localStorage.getItem('user_email') || userEmail || '',
                    rating: 0,
                    feedback: '',
                    productname: 'TrafficMonster',
                    date: currentDate
                });

            })
            .catch((error) => {
                console.error('Error sending feedback:', error);

            });
    };

    const handleTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        // Update feedbackForm with the textarea value
        setFeedbackForm((prevForm) => ({
            ...prevForm,
            feedback: event.target.value,
        }));

    };

    const handleRating = (event: number) => {
        // Update feedbackForm with the textarea value
        setFeedbackForm((prevForm) => ({
            ...prevForm,
            rating: event
        }));

    };

    //Edit functionality in Listing
    const handleEditClick = (blog: IgeneratedbusinessblogDet) => {
        //console.log('blog=>', blog);
        setSelectedBlog(blog);
        setOPenEdit(true);

        const mode = blog.mode || 'Live';
        //console.log(blog.mode);

        let updatedBlogDet = blog.blog_det_draft ? blog.blog_det_draft : blog.blog_det;

        //do some formatting for blog details
        let htmlstring = "<div>";


        {
            (updatedBlogDet) ? updatedBlogDet.split('\n\n').map((paragraph: any, idx: any) => {

                paragraph = paragraph.replace(/\*\*/g, '');
                paragraph = paragraph.replace(/\#\#\#/g, '');
                paragraph = paragraph.replace(/\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+/g, '');
                paragraph = paragraph.replace(/\"/g, '');
                paragraph = paragraph.replace(/:/g, ' ');

                if (paragraph.includes('://') || paragraph.includes('//')) {
                    let newBlogDet = (
                        <div key={idx}><div dangerouslySetInnerHTML={{ __html: paragraph.replace("<h5>", "</br><h5>") }} /><br /></div>
                    );
                    htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);

                } else if (!paragraph.match(/<h5>/) && (paragraph.match(/^(Article|Paragraph [1-3]|Introduction|Conclusion|Blogging 101|Blog|Paragraph [1-3] Heading):/))) {

                    let newBlogDet = (
                        <div key={idx}>
                            <br />
                            <div dangerouslySetInnerHTML={{ __html: paragraph.replace(/^(Article|Paragraph [1-3]|Introduction|Conclusion|Blogging 101|Blog|Paragraph [1-3] Heading):/, '') }} />
                        </div>
                    );
                    htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                } else if (paragraph.includes(':')) {
                    if (paragraph.indexOf(':') < 100) {
                        let parts = paragraph.split(':');
                        let label = parts[0];
                        label = label.replace('<h5>', '');
                        label = label.replace('</h5>', '');
                        label = label.replace('<br>', '');
                        let content = "";
                        if (parts.slice(1).indexOf(":") >= 0) {
                            content = parts.slice(1).join(':');
                        } else
                            content = parts[1];
                        content = content.replace('<h5>', '');
                        content = content.replace('</h5>', '');
                        content = content.replace('<br>', '');
                        let newBlogDet = (
                            <div key={idx}>
                                <h2>{label}:</h2><div dangerouslySetInnerHTML={{ __html: content }} /><br />
                            </div>
                        );
                        htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                    } else {
                        let newBlogDet =
                            (
                                <div key={idx}>
                                    <div dangerouslySetInnerHTML={{ __html: paragraph }} />
                                </div>
                            );
                        htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                    }
                } else {
                    let modifiedParagraph = "";
                    let newparagraph = paragraph.split('\n');
                    if (newparagraph[0].length < 100) {
                        if (newparagraph[0].indexOf("<h5>") !== -1)
                            modifiedParagraph = newparagraph[0];
                        else
                            modifiedParagraph = "<h5>" + newparagraph[0] + "</h5>";
                        for (var i = 1; i < newparagraph.length; i++) {
                            modifiedParagraph = modifiedParagraph + newparagraph[i];
                        }
                    } else {
                        for (var i = 0; i < newparagraph.length; i++) {
                            modifiedParagraph = modifiedParagraph + newparagraph[i];
                        }
                        modifiedParagraph = modifiedParagraph.replace("<h5>", "");
                        modifiedParagraph = modifiedParagraph.replace("</h5>", "");
                        modifiedParagraph = modifiedParagraph.replace("<div", "<div>");
                        modifiedParagraph = modifiedParagraph.replace("</div>", "</div>");
                    }

                    let newBlogDet = (<div key={idx}><div dangerouslySetInnerHTML={{ __html: modifiedParagraph }} /> <br /></div>);
                    htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                    return (
                        ""
                    );
                }
            }) :
                blog.blog_det_draft && blog.blog_det_draft.split('\n\n').map((paragraph: any, idx: any) => {

                    paragraph = paragraph.replace(/\*\*/g, '');
                    paragraph = paragraph.replace(/\#\#\#/g, '');
                    paragraph = paragraph.replace(/\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+\+/g, '');
                    paragraph = paragraph.replace(/\"/g, '');
                    paragraph = paragraph.replace(/:/g, ' ');

                    if (paragraph.includes('://') || paragraph.includes('//')) {
                        let newBlogDet = (
                            <div key={idx}>
                                <div dangerouslySetInnerHTML={{ __html: paragraph.replace("<h5>", "<h5>") }} />
                                <br />
                            </div>
                        );
                        htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                    } else if (!paragraph.match(/<h5>/) && (paragraph.match(/^(Article|Paragraph [1-3]|Introduction|Conclusion|Blogging 101|Blog|Paragraph [1-3] Heading):/))) {
                        let newBlogDet = (
                            <div key={idx}>
                                <br />
                                <div dangerouslySetInnerHTML={{ __html: paragraph.replace(/^(Article|Paragraph [1-3]|Introduction|Conclusion|Blogging 101|Blog|Paragraph [1-3] Heading):/, '') }} />
                            </div>
                        );
                        htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                    } else if (paragraph.includes(':')) {
                        if (paragraph.indexOf(':') < 100) {
                            let parts = paragraph.split(':');
                            let label = parts[0];
                            label = label.replace('<h5>', '');
                            label = label.replace('</h5>', '');
                            label = label.replace('<br>', '');
                            let content = "";
                            if (parts.slice(1).indexOf(":") >= 0) {
                                content = parts.slice(1).join(':');
                            } else
                                content = parts[1];
                            content = content.replace('<h5>', '');
                            content = content.replace('</h5>', '');
                            content = content.replace('<br>', '');
                            let newBlogDet = (
                                <div key={idx}>
                                    <h2>{label}:</h2><div dangerouslySetInnerHTML={{ __html: content }} /><br />
                                </div>
                            );
                            htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                        } else {
                            let newBlogDet = (
                                <div key={idx}>
                                    <div dangerouslySetInnerHTML={{ __html: paragraph }} />
                                </div>
                            );
                            htmlstring = htmlstring + renderToStaticMarkup(newBlogDet);
                        }
                    } else {
                        let modifiedParagraph = "";
                        let newparagraph = paragraph.split('\n');
                        if (newparagraph[0].length < 100) {
                            if (newparagraph[0].indexOf("<h5>") !== -1)
                                modifiedParagraph = newparagraph[0];
                            else
                                modifiedParagraph = "<h5>" + newparagraph[0] + "</h5>";
                            for (var i = 1; i < newparagraph.length; i++) {
                                modifiedParagraph = modifiedParagraph + newparagraph[i];
                            }
                        } else {
                            for (var i = 0; i < newparagraph.length; i++) {
                                modifiedParagraph = modifiedParagraph + newparagraph[i];
                            }
                            modifiedParagraph = modifiedParagraph.replace("<h5>", "");
                            modifiedParagraph = modifiedParagraph.replace("</h5>", "");
                            modifiedParagraph = modifiedParagraph.replace("<div", "<div>");
                            modifiedParagraph = modifiedParagraph.replace("</div>", "</div>");
                        }
                        let newBlogDet = (
                            <div key={idx}>
                                <div dangerouslySetInnerHTML={{ __html: modifiedParagraph }} />
                                <br />
                            </div>
                        );

                        return ("");
                    }
                })
        }

        htmlstring = htmlstring + "</div>";

        htmlstring = htmlstring.replace(/<h5>/g, "<h3>");
        htmlstring = htmlstring.replace(/<\/h5>/g, "</h3>");

        htmlstring = updatedBlogDet;

        //formatting ends
        let user_image = userDets.user_image ? userDets.user_image : '';
        let social_url = userDets.social_url ? userDets.social_url : '';

        const updatedState = {
            id: blog._id,
            blog_title: blog.blog_title_draft || blog.blog_title,
            blog_image_path: blog.blog_image_path_draft || blog.blog_image_path,
            blog_image_string: blog.blog_image_string,
            blog_summary: blog.blog_summary_draft || blog.blog_summary,
            blog_det: htmlstring,
            url: blog.url_draft || blog.url,
            publish_date: blog.publish_date,
            author: blog.author || userDets.name,
            author_image: blog.author_image || user_image,
            author_url: blog.author_url || social_url,
            cta_label: blog.cta_label,
            cta_url: blog.cta_url,
            videotag: blog.videotag ? blog.videotag : planDetails?.videotag,
            product_id: blog.product_id
        };
        setUpdateBlogs(updatedState);

        setTimeout(() => {
            navigate('/ocesha-edit-clip', { state: updatedState });
        }, 0);
    };

    useEffect(() => {
        // If updateblogs are coming from an API or dynamic data
        if (updateblogs) {
            //console.log(updateblogs);
        }
    }, [updateblogs]); //

    const handleDelete = async (blog_id: string) => {
        // const confirmed = window.confirm('Are you sure, you want to delete this blog?');
        // if (confirmed) {
        try {
            const response = await deleteClipMutation({ clip_id: blog_id });
            //console.log(response);
            if ('data' in response) {
                const datas = response.data;
                if (datas.status === 'success') {
                    toast.success('Clip Deleted successfully');

                    // setGeneratedBlogDetail((prevBlogs: any) => {
                    //     const updatedBlogs = prevBlogs.filter((blog: any) => blog.campaign_id !== blog_id);

                    //     return updatedBlogs.map((blog: any, index: any) => ({
                    //         ...blog,
                    //         serialNumber: index + 1,
                    //     }));
                    // });
                    setTimeout(() => {
                        navigate(0);
                    }, 1200);
                }
                else {
                    toast.error('Failed to delete Clip ');
                }
            } else {
                toast.error('Failed to delete Clip ');
            }
        } catch (error) {
            console.error('Error deleting Clip ', error);
            toast.error('An error occurred while deleting the Clip ');
        } finally {
            setDeleteModal(false);
        }
        // }
    }

    const handleRegeneratingBlogClick = async (blog_id: string) => {
        setIsLoading(prevLoadingStates => ({
            ...prevLoadingStates,
            [blog_id]: true
        }));
        try {
            const response = await regenerateBusinessBlogMutation({ blog_id });
            //console.log('response of regeneration=>', response);
            if ('data' in response) {
                const regeneratedResp = response.data;
                if (regeneratedResp.status === 'success') {
                    fetchingPublishDatas('');
                    refetch();
                    timestampInMilliseconds = Date.now();
                    milliSeconds = Math.floor(timestampInMilliseconds / 1000);
                    setMilliSeconds(milliSeconds);
                    // window.location.reload();
                    toast.success(regeneratedResp.msg);
                    setAnchorEl(null);
                }
            }
        } catch (error) {
            console.error('Error deleting Clip', error);
        } finally {
            setIsLoading(prevLoadingStates => ({
                ...prevLoadingStates,
                [blog_id]: false
            }));
        }
    }

    const handleTranscriptClick = async (blog_id: string, desc: string) => {

        // if (planDetails?.subscription_level === 'level_0' || planDetails?.subscription_level === 'level_0y') {
        //     setUpgradeModal(true);
        //     return;
        // } else 
        {


            setIsLoadingTranscript(prevLoadingStates => ({
                ...prevLoadingStates,
                [blog_id]: true
            }));


            try {
                const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                const response = await axios.get(
                    `${apiUrl}/api/prompts/getClipTranscript?clip_id=${blog_id}`,
                );
                //console.log('transcript res=>', response.data);
                if (response.data.status === 'success') {
                    const data = response.data.data;
                    const TranscriptData = data || '';
                    console.log(TranscriptData);
                    setTranscribedData(TranscriptData);
                    setOpenMenuId(null);
                    setTranscriptModal(true);
                } else {
                    console.log('Error fetching transcription data!');
                }
            } catch (error) {
                console.log('error getting transcript=>', error);
            } finally {
                setIsLoadingTranscript(prevLoadingStates => ({
                    ...prevLoadingStates,
                    [blog_id]: false
                }));
            }
        }
    }

    const handleCopyTranscriptClick = () => {
        navigator.clipboard.writeText(`${transcribedData}`).then(() => {
            toast.success('Transcript Copied to Clipboard');
        })
    }

    //console.log(generatedBlogDetail);

    const handelShareClick = async (blog_id: string, publish_to_ocesha: number, publish_to_code_genie: number) => {
        if (userDets?.partner === 1) {
            setBlogIdToPublish(blog_id);
            setPublishBlogModal(true);
        } else {
            try {
                setIsLoadingCopied(prevLoadingStates => ({
                    ...prevLoadingStates,
                    [blog_id]: true
                }));
                // const copyingurl = await copySharingUrlMutation({ blog_id });
                const copyingurl = await publishtogoogleMutation({ blog_id, publish_to_ocesha, publish_to_code_genie });
                //console.log('copyurl publishtogoogle resp=>', copyingurl);
                if ('data' in copyingurl) {
                    const datas = copyingurl.data;
                    if (datas.status === 'success' && datas.msg === 'Submitted for index') {
                        toast.success('Submitted to google indexing');
                    } else {
                        toast.error('Something went wrong, try after some time.');
                    }
                }
            } catch (error) {
                console.error('Error', error);
            } finally {
                setIsLoadingCopied(prevLoadingStates => ({
                    ...prevLoadingStates,
                    [blog_id]: false
                }));
            }
        }
    }


    const PublishToServer = async (blog_id: string, publish_to_ocesha: number, publish_to_code_genie: number) => {
        try {
            setIsLoadingCopied(prevLoadingStates => ({
                ...prevLoadingStates,
                [blog_id]: true
            }));
            // const copyingurl = await copySharingUrlMutation({ blog_id });
            const copyingurl = await publishtogoogleMutation({ blog_id, publish_to_ocesha, publish_to_code_genie });
            //console.log('copyurl publishtogoogle resp=>', copyingurl);
            if ('data' in copyingurl) {
                const datas = copyingurl.data;
                if (datas.status === 'success' && datas.msg === 'Submitted for index') {
                    toast.success('Submitted to google indexing');
                } else {
                    toast.error('Something went wrong, try after some time.');
                }
            }
        } catch (error) {
            console.error('Error', error);
        } finally {
            setIsLoadingCopied(prevLoadingStates => ({
                ...prevLoadingStates,
                [blog_id]: false
            }));
        }
    }

    const handleExportClick = async (blogId: string, url: string, productId: string, title: string, summary: string, blogDet: string, blogImage: string) => {
        //console.log(url);
        const shareUrl = `${baseUrl}prompts/share_clips/${blogId}`;

        await navigator.clipboard.writeText(shareUrl);

        toast.success("Link copied! Paste it in Social Media.");
    }



    const handleDownloadFileClick = async (file_type: string) => {

        if (planDetails?.download_content === true || planDetails?.distribution_to_blogging_platform === true) {
            setIsDownloadLoading(file_type);
            try {
                const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                const response = await axios.post(
                    `${apiUrl}/api/prompts/export?doc_type=${file_type}&blog_id=${blogIdForExport}`,
                    null,
                    {
                        responseType: file_type === 'pdf' || file_type === 'docx' ? 'blob' : 'text',
                        headers: {
                            'Content-Type': file_type.indexOf('clipboard') > -1 ? 'application/json' : 'multipart/form-data',
                        },


                    }
                );


                //console.log('file response=>', response);

                if (file_type === 'pdf' || file_type === 'docx') {
                    // Creating download link from the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `export.${file_type}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } else if (file_type === 'txt') {
                    await navigator.clipboard.writeText(response.data);
                    toast.success('Text has been copied to your clipboard! \r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                        style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
                    });
                } else if (file_type.indexOf('clipboard') > -1) {
                    const parsedContent = JSON.parse(response.data);
                    const targetCopy = parsedContent.target_copy;

                    if (targetCopy === 'html') {
                        try {
                            let htmlContent = parsedContent.html_content;

                            await navigator.clipboard.writeText(htmlContent);

                            const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
                            const htmlClipboardItem = new ClipboardItem({ 'text/html': htmlBlob });
                            await navigator.clipboard.write([htmlClipboardItem]);

                            toast.success('HTML content has been copied to your clipboard! \r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
                            });
                        } catch (err) {
                            toast.error('Failed to copy HTML content.');
                            console.error(err);
                        }

                    } else if (targetCopy === 'text') {
                        try {
                            let textContent = parsedContent.text_conent || ''; // Fix typo here

                            const plainText = textContent
                                .replace(/<br>/g, '\n')
                                .replace(/&nbsp;/g, ' ')
                                .replace(/##/g, '')
                                .replace(/\*\*/g, '')
                                .replace(/<[^>]*>/g, '');

                            //console.log('plainText=>', plainText);

                            await navigator.clipboard.writeText(plainText);

                            const textBlob = new Blob([plainText], { type: 'text/plain' });
                            const textClipboardItem = new ClipboardItem({ 'text/plain': textBlob });
                            await navigator.clipboard.write([textClipboardItem]);

                            toast.success('Text content has been copied to your clipboard! \r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
                            });
                        } catch (err) {
                            toast.error('Failed to copy text content.');
                            console.error(err);
                        }

                    } else if (targetCopy === 'clipboard') {
                        try {
                            const parsedContent = JSON.parse(response.data);
                            var cleanedContent = parsedContent.html_content;
                            var cleanedTextContent = parsedContent.text_conent;
                            const cleanedContentWithHtmlFormatting = cleanedContent
                                .replace(/\\n/g, '<br>')
                                .replace(/\\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
                                .replace(/\\"/g, '')
                                .replace(/```/g, '')
                                .replace(/<\/html> \"/g, '</html>');

                            // Convert cleaned content to plain text by stripping HTML tags
                            const plainTextContent = cleanedTextContent
                                .replace(/<br>/g, '\n') // Replace <br> with newlines
                                .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces with regular spaces
                                .replace(/##/g, '')
                                .replace(/\*\*/g, '')
                                .replace(/<[^>]*>/g, ''); // Remove any remaining HTML tags


                            // Create clipboard item with both text/html and text/plain
                            const clipboardItem = new ClipboardItem({
                                'text/html': new Blob([cleanedContentWithHtmlFormatting], { type: 'text/html' }),
                                'text/plain': new Blob([plainTextContent], { type: 'text/plain' }), // For Notepad compatibility
                            });

                            await navigator.clipboard.write([clipboardItem]);
                            toast.success('Content has been copied to your clipboard! \r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
                            });
                        } catch (err) {
                            toast.error('Failed to copy clipboard content.');
                            console.error(err);
                        }

                    } else {
                        toast.error('Unsupported clipboard content type.');
                    }
                }
                else if (file_type === 'html') {
                    try {
                        let htmlContent = response.data;
                        if (htmlContent.startsWith('"') && htmlContent.endsWith('"')) {
                            htmlContent = htmlContent.slice(1, -1);
                        }

                        //Removing all \n and \t
                        htmlContent = htmlContent.replace(/\\n/g, '').replace(/\n/g, '').replace(/\\t/g, '').replace(/\t/g, '');

                        //Unescaping double quotes \" to "
                        htmlContent = htmlContent.replace(/\\"/g, '"');
                        //Unescaping double quotes \\s to \s
                        htmlContent = htmlContent.replace(/\\\\s/g, '\\s').replace(/\\\\\./g, '\\.');

                        //copying the result to clipboard
                        await navigator.clipboard.writeText(htmlContent);
                        toast.success('HTML has been copied to your clipboard! \r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                            style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
                        });
                    } catch (error) {
                        console.error('Failed to copy HTML content:', error);
                        toast.error('Failed to copy HTML content!');
                    }
                }
            } catch (error) {
                console.log('Unexpected Error:', error);
            } finally {
                setIsDownloadLoading(null);
            }
        } else {
            setUpgradeModal(true);
        }
    };


    const handlemagicIcoClick = async (mode: any) => {
        if (planDetails?.distribution_to_social_media_platform === true) {
            try {
                setIsLoadingEditPost(mode);
                const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                const response = await axios.post(
                    `${apiUrl}/api/prompts/create_hash_tags?blog_id=${blogIdForExport}&social_media=${mode}`,
                    null,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                if (response.data.status === 'Success') {
                    if (response.data.data) {
                        setSharingPostData(response.data.data);
                    } else {
                        setIsLoadingEditPost(null);
                        toast.error('Error fetching data!');
                    }
                } else {
                    setIsLoadingEditPost(null);
                    toast.error('hashtags not created, try again later!');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoadingEditPost(null);
                setOpenPostEdit(true);
            }
        } else {
            setUpgradeModal(true);
        }
    }


    // const useremail = localStorage.getItem('user_email') ?? '';
    const useremail = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : userEmail ? userEmail : getCookie('user_email');



    const handleVideoClick = (url: string) => {
        //console.log('view click blog id=>', blogId);
        //console.log('canoni url=>', canonical_url);
        setHelperVideoSrc(url)
        setHelperPopup(true);

    }

    const params = new URLSearchParams(window.location.search);
    const promptid = params.get('promptid') ?? "";
    const podcastId = params.get('podcastId') ?? ""
    const [selectedCampaign, setSelectedCampaign] = useState('');
    const [campaignListDatas, setCampaignListDatas] = useState<any>();
    const [clipsListDatas, setClipsListDatas] = useState<any>();


    const [campaignListMutation] = useCampaignListMutation();
    const [getGeneratedClipsListings] = useGetGeneratedClipsListingsMutation();
    const [blogGenerationStatusMutation] = useGetBlogGenerationStatusMutation();
    const [generationStatus, setGenerationStatus] = useState<Boolean>(true);
    const [metricStatus, setMetricStatus] = useState('');
    const [totalMetric, setTotalMetric] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 12;
    const domain = window.location.hostname;
    const getBlogsCount = useClipsListingsCountQuery({
        userid: useremail || getCookie('user_email') || '',
        product_id: localStorage.getItem('podcastId') || '',
        search: searchTerm,
        fromDate,
        toDate,
    });
    const getCampaignBlogsCount = useCampaignBlogsCountQuery({ campaignid: selectedCampaign || '', userid: useremail || getCookie('user_email') || '', cat: "", query: "", domain: domain });
    const getProducts = useGetproductsDetQuery({ user_id: useremail || getCookie('user_email') || '' });
    const getBlogs = useGetgeneratedBlogListingsQuery({ promptid: promptid, userid: user_email || getCookie('user_email') || '', limitval: pageSize, skipval: (currentPage - 1) * pageSize });
    const getCampaignBasedBlogs = useGetBlogsByCampaignQuery({ campaignid: selectedCampaign || '', limitval: pageSize, skipval: (currentPage - 1) * pageSize });
    const getCampaignStatusBasedBlogs = useGetBlogsByCampaignstatusQuery({ campaignid: selectedCampaign || '', limitval: pageSize, skipval: (currentPage - 1) * pageSize, status: metricStatus })
    /* for image updation frequently */
    const { data, error, refetch } = useGetgeneratedBlogListingsQuery({
        promptid: promptid,
        userid: user_email || '',
        limitval: pageSize,
        skipval: (currentPage - 1) * pageSize
    });
    const [totalPages, setTotalPages] = useState(Math.ceil((getBlogsCount?.data ?? 0) / pageSize));
    const [totalPagesFiltered, setTotalPagesFiltered] = useState(totalPages);
    type IntervalId = ReturnType<typeof setInterval>;
    const intervalIdRef = useRef<IntervalId | null>(null);
    const [query, setQuery] = useState('');
    const [images, setImages] = useState<UnsplashImage[]>([]);
    const [unsplashSearch, setUnsplashSearch] = useState<boolean>(false);
    const [findText, setFindText] = useState('');
    const [replaceText, setReplaceText] = useState('');
    const [updatedText, setUpdatedText] = useState('');
    const [matches, setMatches] = useState<number[]>([]);
    const [currentMatchIndex, setCurrentMatchIndex] = useState<number>(-1);

    const campaignRes = async () => {
        try {
            const response = await campaignListMutation({ email: user_email || '' });
            if ('data' in response) {
                setCampaignListDatas(response.data);
                //console.log('campaign list response=>', response.data)
            } else {
                //console.error('Error fetching campaign List:', response.error);
            }
        } catch (error) {
            //console.log('Error fetching campaign List:', error);
        }
    }


    const clipsListsRes = async () => {
        try {
            const response = await getGeneratedClipsListings({ email: useremail || '', product_id: '', limitval: 12, skipval: 0, search: searchstr || '' });
            if ('data' in response) {
                setClipsListDatas(response.data);
                //console.log('Episode list response=>', response.data)
            } else {
                //console.error('Error fetching campaign List:', response.error);
            }
        } catch (error) {
            //console.log('Error fetching campaign List:', error);
        }
    }


    const handlecampaignSelectionChange = (event: any, fromCampaign: any, fromUpdatedCampaign: any) => {
        localStorage.removeItem('publishingCampId');
        const selectedValue = event.target.value || fromCampaign || fromUpdatedCampaign;
        // setSelectedCampaign(event.target.value);
        setSelectedCampaign(selectedValue);
        //console.log('Selected campaign:', event.target.value);//getting selected campaign id here
        // fetchingPublishDatas(event.target.value);
        fetchingPublishDatas(selectedValue);
        localStorage.setItem('campId', selectedValue);
        // localStorage.setItem('selectedCamp', selectedValue);
    };

    useEffect(() => {
        const publishingblogCampId = localStorage.getItem('publishingCampId');
        if (publishingblogCampId) {
            setSelectedCampaign(publishingblogCampId);
            fetchingPublishDatas(publishingblogCampId);
        }
        else if (FromCampaign) {

            setSelectedCampaign(FromCampaign);
            fetchingPublishDatas(FromCampaign);
            localStorage.setItem('campId', FromCampaign);

            const count = 0;
            localStorage.setItem('refreshCount', count.toString());

            const refreshPage = () => {
                const refreshCountStr = localStorage.getItem('refreshCount');
                const refreshCountt = refreshCountStr !== null ? parseInt(refreshCountStr) : 0;

                if (refreshCountt < 1) {
                    setTimeout(() => {
                        localStorage.setItem('refreshCount', (refreshCountt + 1).toString());
                        // window.location.reload();
                        setSelectedCampaign(FromCampaign);
                        fetchingPublishDatas(FromCampaign);

                        // processBlogs();

                    }, 20000);
                }
            };
            refreshPage();

            // **Set FromCampaign to null**
            navigate(location.pathname, {
                replace: true,
                state: { ...location.state, FromCampaign: null },
            });

        } else if (FromUpdatedCampaign) {
            setSelectedCampaign(FromUpdatedCampaign);
            fetchingPublishDatas(FromUpdatedCampaign);
            localStorage.setItem('campId', FromUpdatedCampaign);
        } else if (campaignListDatas && campaignListDatas.length > 0 /* && !selectedCampaign */) {
            const savedCampId = localStorage.getItem('campId');
            if (!savedCampId) {
                // Only set to the 0th index if no other campaign was previously selected
                setSelectedCampaign(campaignListDatas[0].campaign_id);
                fetchingPublishDatas(campaignListDatas[0].campaign_id);
                localStorage.setItem('campId', campaignListDatas[0].campaign_id);
            } else {
                setSelectedCampaign(savedCampId);
                fetchingPublishDatas(savedCampId);
            }
        }
    }, [campaignListDatas, FromCampaign, FromUpdatedCampaign, location, navigate])

    useEffect(() => {
        //campaignRes();
        clipsListsRes();
    }, []);



    const checkForUnupdatedImages = () => {
        refetch();
        timestampInMilliseconds = Date.now();
        milliSeconds = Math.floor(timestampInMilliseconds / 1000);
        setMilliSeconds(milliSeconds);
    }

    const BlogGenerationStatus = async () => {
        try {
            const response = await blogGenerationStatusMutation({ campaignid: localStorage.getItem('campId') || FromCampaign/* selectedCampaign || FromCampaign || '' */ });

            if ('data' in response) {
                const currentStatus = response.data.status;
                const imageUpdated = Boolean(currentStatus);

                setGenerationStatus(response.data.status);
                if (response.data.status == false) {
                    checkForUnupdatedImages();
                    fetchingPublishDatas(localStorage.getItem('campId') || '');
                }

                //check still image is not refreshed or not and call the list api again
                generatedBlogDetail.map((blog: any, index: any) => {
                    // Check some data within each blog
                    if (blog.blog_image_path.indexOf("/images/blogs12.png") > -1) {
                        checkForUnupdatedImages();
                        fetchingPublishDatas(localStorage.getItem('campId') || '');
                    }

                });

                //console.log('generation status response=>', response.data.status)
            } else {
                //console.error('Error fetching     blog generation status:', response.error);
            }
        } catch (error) {
            //console.log('Error fetching blog generation status:', error);
        }
    }

    useEffect(() => {
        let timerId: any;
        const checkForUnupdatedImages = () => {
            const UnupdatedImage = data && data.some((blog: any) => blog.image_updated === 'No');
            if (UnupdatedImage) {
                refetch();
                timestampInMilliseconds = Date.now();
                milliSeconds = Math.floor(timestampInMilliseconds / 1000);
                setMilliSeconds(milliSeconds);
            }
        }

        if (generationStatus === false) {

            checkForUnupdatedImages();

            if (error) {
                //console.log(error);
            }

            timerId = setInterval(() => {
                checkForUnupdatedImages();
                const unupdatedImageExists = data && data.some((blog: any) => blog.image_updated === 'No');
                if (!unupdatedImageExists) {
                    clearInterval(timerId);
                }
            }, 5000);
        }
        return () => clearInterval(timerId);
    }, [data, error, refetch]);

    useEffect(() => {

        if (getBlogs && getBlogs.data) {

            const updatedBlogs = getBlogs && getBlogs.data.map((blog: any, index: any) => ({
                ...blog,
                serialNumber: (currentPage - 1) * pageSize + index + 1,
            }));
            if (selectedBlogTitle) {
                const filtered = updatedBlogs.filter((blog: any) => blog.blog_title === selectedBlogTitle);
                const paginatedBlogs = filtered.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                );
                setGeneratedBlogDetail(paginatedBlogs);
                setTotalPagesFiltered(Math.ceil(filtered.length / pageSize));
            }
            else if (fromDate || toDate) {
                const fromDateObj = fromDate ? new Date(fromDate).setHours(0, 0, 0, 0) : null;
                const toDateObj = toDate ? new Date(toDate).setHours(23, 59, 59, 999) : null;

                const filteredBlogs = updatedBlogs.filter((blog: any) => {
                    const blogDate = new Date(blog.created_date).setHours(0, 0, 0, 0);

                    if (fromDateObj && toDateObj) {
                        return blogDate >= fromDateObj && blogDate <= toDateObj;
                    } else if (fromDateObj) {
                        return blogDate >= fromDateObj;
                    } else if (toDateObj) {
                        return blogDate <= toDateObj;
                    }
                    return true; // If no date filters are applied, return all
                });

                const paginatedBlogs = filteredBlogs.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                );
            }
        }
    }, [getBlogs, currentPage, selectedBlogTitle, pageSize]);

    // useEffect(() => {
    //     if (userDets?.subscription_level === '' && generatedBlogDetail?.length > 0) {
    //         setToUpgrade(true);
    //         setUpgradeModal(true);
    //     } else if (generatedBlogDetail?.length <= 0) {
    //         setHelperVideoSrc("/images/My_Blogs_Page.mp4");
    //         //setHelperPopup(true);
    //     }
    // }, [userDets?.subscription_level, generatedBlogDetail?.length]);

    const handlePublishedClick = () => {
        setMetricStatus('Live');
        setTotalMetric('');
    };

    const handleUnpublishedClick = () => {
        setMetricStatus('draft');
        setTotalMetric('');
    };

    useEffect(() => {
        if (getProducts) {
            setProductDetail(getProducts.data);

            const productDet = getProducts.data?.map((product: any, index: any) => ({
                ...product
            }));

            setProductDetail(productDet)

        }
    }, [getProducts]);


    useEffect(() => {
        const producturl = productDetail ? productDetail.map((product: any) => product.url ?? '') : '';
        setProductURL(producturl[0]);

    }, [productDetail])

    const defaultClipsTitles = generatedBlogDetail ? generatedBlogDetail.map((blog: any) => blog.title || "") : [];
    const searchClipsTitles = generatedBlogDetailSearch ? generatedBlogDetailSearch.map((blog: any) => blog.title || "") : [];
    const dropdownList = searchQuery
        ? (searchClipsTitles.length ? searchClipsTitles : defaultClipsTitles)
        : defaultClipsTitles;

    const handleToggleClick = () => {
        navigate('/codegenie/blogs-list');
    }
    const handleToggleClick1 = () => {
        localStorage.setItem('activeItem', 'blogs');
        navigate('/codegenie/generated-blogs');
    }

    const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setImageFile(file);

            const objectUrl = URL.createObjectURL(file);
            setBlogImg(objectUrl);
        }
    };

    const accessKey = 'hT9C64LpMAlpDRMJ-Wbt8IBbUKICCu7JfbLjxmebTvo';

    const handleAuthorImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setAuthorImgFile(file);

            const objectUrl = URL.createObjectURL(file);
            setAuthorImg(objectUrl);
        }
    };

    const handleSearch = async () => {
        setUnsplashSearch(true);
        if (!query) {
            toast.error('Please enter any value to search');
        } else {
            try {
                const response = await axios.get(`https://api.unsplash.com/search/photos?client_id=${accessKey}`, {
                    params: { query, per_page: 20 },
                });
                setImages(response.data.results);
            } catch (error) {
                console.error("Error fetching images from Unsplash", error);
            }
        }
    };

    const horizontalImages = images.filter(image => image.width > image.height);

    const handleSelectUnsplashImage = async (imageUrl: any, imageid: any) => {
        setSelectedUnsplashImg(imageid);
        setBlogImg(imageUrl);

        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], "unsplash_image.jpg", { type: blob.type });

        setImageFile(file);
    };

    useEffect(() => {
        return () => {
            if (blogImg) {
                URL.revokeObjectURL(blogImg);
            }
        };
    }, [blogImg]);

    const handleUnsplashselectionChange = () => {
        if (!blogImg) {
            toast.error('Please select any image!');
        } else {
            setOpenUnsplash(false);
        }
    }

    const handlesaveDraft = async () => {
        setIsDraftOrPublishLoading(true);
        const formData = new FormData();
        formData.append('id', selectedBlog?._id || '');
        formData.append('blog_title', updateblogs.blog_title);
        formData.append('blog_image_string', updateblogs.blog_image_string);
        if (imageFile) {
            formData.append('blog_image', imageFile);
        }
        formData.append('blog_summary', updateblogs.blog_summary);
        formData.append('blog_det', updateblogs.blog_det);
        formData.append('url', updateblogs.url);
        formData.append('cta_url', updateblogs.cta_url);
        formData.append('cta_label', updateblogs.cta_label);
        formData.append('author', updateblogs.author);
        if (authorImgFile) {
            formData.append('autor_image', authorImgFile);
        }
        formData.append('author_url', updateblogs.author_url);
        formData.append('videotag', updateblogs.videotag);

        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + '/api/prompts/savecontentasdraft', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.data.status === 'success') {
                refetch();
                timestampInMilliseconds = Date.now();
                milliSeconds = Math.floor(timestampInMilliseconds / 1000);
                setMilliSeconds(milliSeconds);
                toast.success('Blog saved Successfully!!');
            } else {
                toast.error('Something went wrong!');
            }
            setOPenEdit(false);
        } catch (error) {
            console.error('Error updating blog:', error);
        } finally {
            setIsDraftOrPublishLoading(false);
        }
    };

    const handlePublished = async () => {
        localStorage.setItem('publishingCampId', selectedCampaign);
        setIsDraftOrPublishLoading(true);
        const formData = new FormData();
        formData.append('id', selectedBlog?._id || '');
        formData.append('blog_title', updateblogs.blog_title);
        formData.append('blog_image_string', updateblogs.blog_image_string);
        if (imageFile) {
            formData.append('blog_image', imageFile);
        }
        formData.append('blog_summary', updateblogs.blog_summary);
        formData.append('blog_det', updateblogs.blog_det);
        formData.append('url', updateblogs.url);
        formData.append('cta_url', updateblogs.cta_url);
        formData.append('cta_label', updateblogs.cta_label);
        formData.append('author', updateblogs.author);
        if (authorImgFile) {
            formData.append('autor_image', authorImgFile);
        }
        formData.append('author_url', updateblogs.author_url);
        formData.append('videotag', updateblogs.videotag);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + '/api/prompts/publishcontent', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.data.status === 'success') {
                toast.success('Blog Published Successfully!!');
                refetch();
                timestampInMilliseconds = Date.now();
                milliSeconds = Math.floor(timestampInMilliseconds / 1000);
                setMilliSeconds(milliSeconds);
            } else {
                toast.error('Something went wrong!');
            }
            setOPenEdit(false);
        } catch (error) {
            console.error('Error updating blog:', error);
        } finally {
            setIsDraftOrPublishLoading(false);
        }
    };

    const fetchData = async () => {
        try {
            const response = await getUserDetailsMutation({ email: useremail || getCookie('user_email') || '', filter: '', start_date: '', end_date: '' });
            if ('data' in response) {
                setUserDets(response.data.data);
            }
        } catch (error) {
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    const fetchingPublishDatas = async (campaignId: string) => {
        try {
            const responseCount = await publishUnpublishCountMutation({ email: useremail || getCookie('user_email') || '', campaignid: campaignId });
            if ('data' in responseCount) {
                const datas = responseCount.data;
                setPublishedUnpublishedCount(datas);
            }
        } catch (error) {
            //console.log('Error fetching publishing counts data:', error);
        }
    }
    useEffect(() => {
        fetchingPublishDatas('');
    }, []);

    useEffect(() => {
        const handleStorageChange = () => {
            setFreePlan(localStorage.getItem('free_plan'));
            setSubscriptionLevel(localStorage.getItem('subscription_level'));
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);


    useEffect(() => {

        const { data } = getProductState;
        if (data?.plan_details) {
            setPlans([...data?.plan_details]);
        }
        else
            setPlans([
                {
                    user: 1,
                    plan_name: "",
                    total_wishes: 0,
                    price: "",
                    period: "",
                    product_id: "",
                    price_id: "",
                    subscription_level: "",
                    feature: [],
                    contracts: 0,
                    type: "",
                    button_text: "",
                    save: ''
                },
            ]);
    }, [getProductState]);
    const [isWideScreen, setIsWideScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth <= 1366 && window.innerHeight <= 768);
        };

        handleResize(); // Initial call
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        localStorage.removeItem('prevImg');
    }, [])

    const handlePreviewBlogClick = async (blog_image: any, blog_id: string, productId: string) => {
        localStorage.setItem('prevImg', '');
        if (blog_image) {
            setPrevImgLoader(true);
            const formData = new FormData();
            formData.append('blog_image', blog_image);
            formData.append('blog_id', blog_id);
            try {
                const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                const response = await axios.post(apiUrl + '/api/prompts/getBlogDetwihtImage', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                localStorage.setItem('prevImg', response.data.temp_image_path);
            } catch (error) {
                //console.error('Error during API call:', error);
            } finally {
                setPrevImgLoader(false);
                window.open(`/PreviewBlogs/${updateblogs.id}?campId=${productId}`, '_blank');
            }
        } else {
            window.open(`/PreviewBlogs/${updateblogs.id}?campId=${productId}`, '_blank');
        }
    };

    const handleCTALabelChange = (e: any) => {
        const newValue = e.target.value;
        setPlanDetails((prevDetails: any) => ({
            ...prevDetails,
            cta_lable: newValue
        }));
        setUpdateBlogs(prevState => ({
            ...prevState,
            cta_label: newValue
        }));
    }

    const handleCTALinkChange = (e: any) => {
        const newValue = e.target.value;
        setPlanDetails((prevDetails: any) => ({
            ...prevDetails,
            cta_link: newValue
        }));
        setUpdateBlogs(prevState => ({
            ...prevState,
            cta_url: newValue
        }));
    }

    const handlevideochange = (event: any) => {
        const newVideotag = event.target.value;
        setUpdateBlogs((prevBlogs) => ({
            ...prevBlogs,
            videotag: newVideotag,
        }));
    };


    const modifyImageUrl = (url: any) => {
        let modifiedUrl = new URL(url);

        modifiedUrl.searchParams.set('fit', 'none');

        modifiedUrl.searchParams.set('w', '1152');

        modifiedUrl.searchParams.set('h', '500');

        return modifiedUrl.toString();
    };

    const handleMenuOpenClick = (index: any) => {
        if (isMenuDropdownOpen === index) {
            setIsMenuDropdownOpen(null);
        } else {
            setIsMenuDropdownOpen(index);
        }
    }

    const youtubeplaceholderText = 'https://www.youtube.com/watch?v=X7sEkixKk4g&t=1s';

    const handleContinueRegClick = () => {
        navigate('/pricing', { state: { 'campaignIdFromBL': localStorage.getItem('campId'), 'from_page': 'campaign_list', 'useremail': userDets?.email || getCookie('user_email') || '' } });
    }

    useEffect(() => {
        // Initialize updatedText when selectedCampaign changes
        const selectedCampaignData = campaignListDatas?.find((campaign: any) => campaign.campaign_id === selectedCampaign);
        if (selectedCampaignData) {
            setUpdatedText(selectedCampaignData.product_desc);
        }
    }, [selectedCampaign, campaignListDatas]);

    const handleTranscribedTextAreaChange = (value: any) => {
        const updatedCampaignList = campaignListDatas.map((campaign: any) => {
            if (campaign.campaign_id === selectedCampaign) {
                return { ...campaign, product_desc: value };
            }
            return campaign;
        });
        setCampaignListDatas(updatedCampaignList);
        setUpdatedText(value);
    }

    const handleTranscribedSaveClick = async (campaignid: any, productsdesc: any) => {
        setIsTranscribeEditable(false);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.get(
                `${apiUrl}/api/products/update_original_text?campaignid=${campaignid}&new_product_desc=${productsdesc}`,
            );
            if (response.data.status === 'success') {
                toast.success(response.data.data);
                localStorage.setItem('activeItem', 'clips');
                window.location.reload();
            } else {
                toast.error('updating failed!');
            }
        } catch (error) {
            console.log(error);
        }
    }

    // Handle Find and Replace
    const handleFind = () => {
        if (findText) {
            if (matches.length === 0) {
                const indices: number[] = [];
                const regex = new RegExp(findText, "gi");
                let match;

                while ((match = regex.exec(updatedText)) !== null) {
                    indices.push(match.index);
                }

                if (indices.length > 0) {
                    setMatches(indices);
                    setCurrentMatchIndex(0);
                }
            } else {
                const nextIndex = (currentMatchIndex + 1) % matches.length;
                setCurrentMatchIndex(nextIndex);
            }
        }
    };

    const handleReplace = () => {
        if (findText && currentMatchIndex !== -1) {
            const start = matches[currentMatchIndex];
            const end = start + findText.length;

            const updatedContent =
                updatedText.substring(0, start) +
                replaceText +
                updatedText.substring(end);

            setUpdatedText(updatedContent);
            handleTranscribedTextAreaChange(updatedContent);

            setMatches([]);
            setCurrentMatchIndex(-1);
        }
    };

    const handleReplaceAll = () => {
        if (findText) {
            const updatedContent = updatedText.replace(new RegExp(findText, "g"), replaceText);
            setUpdatedText(updatedContent);
            handleTranscribedTextAreaChange(updatedContent);

            setMatches([]);
            setCurrentMatchIndex(-1);
        }
    };

    const outputRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (outputRef.current) {
            const highlightedElement = outputRef.current.querySelector(`#current-match`);
            if (highlightedElement) {
                highlightedElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [currentMatchIndex]);

    const getHighlightedText = () => {
        if (!findText || matches.length === 0) {
            return { __html: updatedText.replace(/\n/g, '<br>') };
        }

        const regex = new RegExp(`(${findText})`, 'gi');
        const highlightedContent = updatedText.replace(regex, (match, group, offset) => {
            const isCurrentMatch = matches[currentMatchIndex] === offset;
            return `<span id="${isCurrentMatch ? "current-match" : ""}" style="background-color: ${isCurrentMatch ? "yellow" : "lightgray"
                }; font-weight: ${isCurrentMatch ? "bold" : "normal"}; color: ${isCurrentMatch ? "#000" : "#000"};">${match}</span>`;
        });

        return { __html: highlightedContent.replace(/\n/g, '<br>') };
    };

    const handleItemClick = (itemName: any, podcostId: any, title: any) => {
        localStorage.setItem('activeItem', itemName);
        localStorage.setItem('podcastId', podcostId)

        if (itemName == 'createcontent') {
            navigate('/codegenie/new-podcast');
        }
        else if (itemName == "clips") {
            window.location.href = `/codegenie/generated-blogs?itemName=${encodeURIComponent(itemName)}&podcostId=${encodeURIComponent(podcostId)}&title=${encodeURIComponent(title)}`;
        }
        else if (itemName == "images") {
            window.location.href = `/codegenie/generated-blogs?itemName=${encodeURIComponent(itemName)}&podcostId=${encodeURIComponent(podcostId)}&title=${encodeURIComponent(title)}`;
        }
    };

    const handleDeleteClick = (blogId: any) => {
        setDeleteBlogId(blogId);
        setDeleteModal(true);
    }

    const handleClick = (event: any, blogId: any, productId: any) => {
        if (openMenuId === blogId) {
            setOpenMenuId(null);
        } else {
            setOpenMenuId(blogId);
        }
        setAnchorEl(event.currentTarget);
        setBlogidofsubmenu(blogId);
        setProductIdofSubmenu(productId);
    };

    const handleClose = () => {
        setOpenMenuId(null);
    };

    const handlePublishToOceshaChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToOcesha(isChecked);
    };

    const handlePublishToCodegenieChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToCodegenie(isChecked);
    };

    const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        if (code) {
            axios.get(`${apiUrl}/api/wordpress/callback?code=${code}`).then(res => {
                localStorage.setItem("wp_token", res.data.access_token);
                alert("WordPress connected!");
            });
        }
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('wp_token');
        const site = localStorage.getItem('wp_site');

        if (token && site) {
            setWpAccessToken(token);
            setWpSite(site);
        }
    }, []);

    const handlePostToWordPress = () => {
        if (!wpAccessToken) {
            window.location.href = `https://public-api.wordpress.com/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code`;
        } else {
            postToWordPress();
        }
    };

    useEffect(() => {
        const shouldTrigger = localStorage.getItem("trigger_wp_post") === "true";
        const exportBlogId = localStorage.getItem("blog_id_for_export");

        const blogToExport = generatedBlogDetail?.find((b: any) => b._id === exportBlogId);

        if (shouldTrigger && blogToExport && !wpTriggered.current) {
            wpTriggered.current = true;

            handleExportClick(
                blogToExport._id,
                blogToExport.url,
                blogToExport.product_id,
                blogToExport.blog_title,
                blogToExport.blog_summary,
                blogToExport.blog_det,
                blogToExport.blog_image_path
            );
        }
    }, [generatedBlogDetail]);

    useEffect(() => {
        const shouldTrigger = localStorage.getItem("trigger_wp_post") === "true";

        if (
            shouldTrigger &&
            openExportModal &&
            titleForExport &&
            blogDetForExport &&
            imageForExport &&
            wpAccessToken &&
            wpSite
        ) {
            handlePostToWordPress();
            localStorage.removeItem("trigger_wp_post");
            localStorage.removeItem("blog_id_for_export");
        }
    }, [openExportModal, titleForExport, blogDetForExport, imageForExport, wpAccessToken, wpSite]);

    useEffect(() => {

        let intervalId: any;
        if (loadingBlog && loaderProgress < 100) {
            intervalId = setInterval(() => {
                setLoaderProgress((prevProgress: any) => {
                    const newProgress = prevProgress + 2;
                    return newProgress >= 98 ? 98 : newProgress;
                });
            }, intervaltime);
        }

        return () => clearInterval(intervalId);
    }, [loadingBlog, loaderProgress]);

    const postToWordPress = async () => {
        setLoadingBlog(true);
        setLoaderProgress(10);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const imageURL = `${window.location.origin}${imageForExport}`;
            const imageHTML = `<img src="${imageURL}" alt="Blog image" style="width: 100%;" />`;
            const contentWithImage = `${imageHTML}\n${blogDetForExport.replace(/<script.*?>.*?<\/script>/gi, '')}`;
            const res = await fetch(`${apiUrl}/api/wordpress/post-blog`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    access_token: wpAccessToken,
                    site: wpSite,
                    title: titleForExport,
                    content: contentWithImage,
                }),
            });

            let data = null;
            if (res.ok) {
                try {
                    data = await res.json();
                } catch (jsonErr) {
                    console.warn('Response not JSON:', jsonErr);
                }
            } else {
                const errText = await res.text();
                console.warn('Non-OK response:', res.status, errText);
            }

            if (res.ok || data?.ID || data?.id) {
                setLoaderProgress(100);
                setTimeout(() => {
                    setLoadingBlog(false);
                    toast.success('Blog posted to WordPress!');
                }, 2000);
            } else {
                setLoadingBlog(false);
                alert('❌ Failed to post blog.');
                console.error('Error response:', data);
            }

        } catch (err: any) {
            setLoadingBlog(false);
            alert('⚠️ Blog likely posted, but response failed.');
            console.error('Network or fetch() error:', err?.message || err);
        }
    };

    const handlePostwordpressorg = async () => {
        setWpLoading(true);
        const imageURL = `${window.location.origin}${imageForExport}`;
        const imageHTML = `<img src="${imageURL}" alt="Blog image" style="width: 100%;" />`;
        const contentWithImage = `${imageHTML}\n${blogDetForExport.replace(/<script.*?>.*?<\/script>/gi, '')}`;

        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || '';

        const res = await fetch(`${apiUrl}/api/wordpress/post-to-wporg`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                wp_url: wpUrl,
                username: wpUsername,
                app_password: wpPassword.replace(/\s+/g, ''),
                title: titleForExport,
                content: contentWithImage,
            }),
        });

        const data = await res.json();

        if (res.ok) {
            toast.success('Blog posted successfully!');
            setWordpressModal(false);
            setWpUrl('');
            setWpUsername('');
            setWpPassword('');
            setWpLoading(false);
        } else {
            toast.error('Failed to post blog.');
            setWordpressModal(false);
            setWpUrl('');
            setWpUsername('');
            setWpPassword('');
            setWpLoading(false);
            console.error(data);
        }
    };

    // ─── NEW: per-clip publish icon handler ──────────────────────────────────────
    const handlePublishIconClick = async (blog: any) => {
        const clipId = blog.campaign_id;
        setIsPublishLoading((prev) => ({ ...prev, [clipId]: true }));
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const emailToUse = user_email || getCookie('user_email') || '';

            // Build suggestion directly from clip data (no slow API polling)
            const desc = blog.description || blog.product_desc || blog.title || '';
            const keyPoints = [
                desc.substring(0, 150),
                desc.substring(150, 300),
                desc.substring(300, 450),
            ].filter((kp: string) => kp.trim() !== '');

            const payload = {
                suggestion: {
                    type: 'dummy_clip_post',
                    title: blog.title || '',
                    hook: desc.substring(0, 300),
                    source_reference: blog.title || '',
                    platform: 'twitter',
                    estimated_engagement: 'high',
                    content_angle: 'informative',
                    key_points: keyPoints.length > 0 ? keyPoints : [desc.substring(0, 150)],
                    image_url: blog.thumbnail || blog.thump_image_path || '',
                    image_url_small: blog.thumbnail || blog.thump_image_path || '',
                    video_url: blog.video_path || '',
                    post_type: "clips",
                    source_id: blog.campaign_id
                },
            };

            const response = await axios.post(
                `${apiUrl}/api/prompts/api/posts/generate?user_email=${encodeURIComponent(emailToUse)}`,
                payload,
                { headers: { 'Content-Type': 'application/json', accept: 'application/json' } },
            );

            if (response.data.status === 'success') {
                const post = response.data.posts[0];

                //setPublishSuccessModal(true);

                // Activate (non-blocking)
                // try {
                //     await axios.post(
                //         `${apiUrl}/api/prompts/api/posts/${post.id}/activate?user_email=${encodeURIComponent(emailToUse)}`,
                //         {},
                //         { headers: { accept: 'application/json' } },
                //     );
                // } catch (_e) { /* non-blocking */ }

                const returnDomain = (process.env.REACT_APP_RETURN_DOMAIN_NAME || "").replace(/\/$/, "");
                const contentUrl = (post.content_url || "").replace(/^\//, "");

                navigate('/ocesha/publish-schedule-clip', {
                    state: {
                        postContent: post?.content || desc,
                        postId: post?.id || '',
                        clipTitle: post.suggestion_title || blog.title || '',
                        clipThumbnail: blog.thumbnail || blog.thump_image_path || '',
                        platform: post.platform || "",
                        blogId: clipId,
                        sourceType: 'clip',
                        blogUrl: contentUrl ? `${returnDomain}/${contentUrl}` : "",
                    },
                });
            } else {
                toast.error('Failed to generate post or duplicate post.');
            }
        } catch (error) {
            console.error('Publish icon error:', error);
            toast.error('Something went wrong');
        } finally {
            setIsPublishLoading((prev) => ({ ...prev, [clipId]: false }));
        }
    };

    const handleClipSelection = (clipId: string) => {
        setSelectedClipIds((prev) =>
            prev.includes(clipId)
                ? prev.filter((id) => id !== clipId)
                : [...prev, clipId]
        );
    };

    const handleDeleteSelectedClips = async () => {
        if (selectedClipIds.length === 0) {
            toast.warning("Please select at least one clip");
            return;
        }

        try {
            const response = await deleteMultipleClipsMutation({
                clip_ids: selectedClipIds,
            });

            if ("data" in response && response.data.status === "success") {
                toast.success(response.data.message);

                setGeneratedBlogDetail((prev: any) =>
                    prev.filter(
                        (clip: any) => !selectedClipIds.includes(clip.campaign_id)
                    )
                );

                setSelectedClipIds([]);
                setDeleteModal(false);
                setTimeout(() => {
                    navigate(0);
                }, 1200);
            } else {
                toast.error("Failed to delete clips");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error deleting clips");
        }
    };

    const allClipsSelected =
        generatedBlogDetail?.length > 0 &&
        selectedClipIds.length === generatedBlogDetail.length;

    const someClipsSelected =
        selectedClipIds.length > 0 &&
        selectedClipIds.length < generatedBlogDetail.length;

    const buildClipPayload = (blog: any) => {
        const desc =
            blog.description ||
            blog.product_desc ||
            blog.title ||
            "";

        const keyPoints = [
            desc.substring(0, 150),
            desc.substring(150, 300),
            desc.substring(300, 450),
        ].filter((kp: string) => kp.trim() !== "");

        return {
            suggestion: {
                type: "Social Post",
                title: blog.title || "",
                hook: desc.substring(0, 300),
                source_reference: blog.title || "",
                platform: "twitter",
                estimated_engagement: "high",
                content_angle: "informative",
                key_points:
                    keyPoints.length > 0
                        ? keyPoints
                        : [desc.substring(0, 150)],
                image_url:
                    blog.thumbnail ||
                    blog.thump_image_path ||
                    "",
                image_url_small:
                    blog.thumbnail ||
                    blog.thump_image_path ||
                    "",
                video_url: blog.video_path || "",
                post_type: "clips",
                source_id: blog.campaign_id,
            },
        };
    };

    const handleBulkPublishClips = async () => {
        try {
            setIsBulkPublishing(true);

            const apiUrl =
                process.env.REACT_APP_SERVER_ENDPOINT || "";

            const emailToUse =
                user_email ||
                getCookie("user_email") ||
                "";

            const selectedClips =
                generatedBlogDetail.filter((clip: any) =>
                    selectedClipIds.includes(
                        clip.campaign_id
                    )
                );

            await Promise.all(
                selectedClips.map((clip: any) =>
                    axios.post(
                        `${apiUrl}/api/prompts/api/posts/process_generate_multiple_trigger?user_email=${encodeURIComponent(
                            emailToUse
                        )}`,
                        buildClipPayload(clip),
                        {
                            headers: {
                                "Content-Type":
                                    "application/json",
                                accept: "application/json",
                            },
                        }
                    )
                )
            );

            toast.success(
                "Post generation initiated, will be completed in few seconds. Head to your Dashboard and check the Generated Content List shortly."
            );

            setSelectedClipIds([]);
        } catch (error) {
            console.error(
                "Bulk clip publish error:",
                error
            );

            toast.error(
                "Failed to initiate post generation"
            );
        } finally {
            setIsBulkPublishing(false);
        }
    };

    const handleDescriptionUpdate = async (blog: any) => {
        setUpdatingTranscription(true);
        try {
            const formData = new FormData();
            formData.append("id", blog.campaign_id);
            formData.append("title", editedTitle);
            formData.append("transcript", editedDescription || blog.transcript);

            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const res = await axios.post(
                `${apiUrl}/api/prompts/update_clip_text`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.data.status === 'success') {
                toast.success(res.data?.message);

                /* setGeneratedBlogDetail((prev: any) =>
                    prev.map((item: any) =>
                        item.campaign_id === blog.campaign_id
                            ? { ...item, description: editedDescription }
                            : item
                    )
                ); */
                await fetchClipsData(
                    pageSize,
                    (currentPage - 1) * pageSize,
                    searchTerm,
                    fromDate,
                    toDate
                );
            } else {
                toast.error('something went wrong, please try again later!');
            }

            setEditingDescriptionId(null);
            setEditingTitleId(null);
            setEditedDescription("");
            setEditedTitle("");
        } catch (err) {
            console.error(err);
        } finally {
            setUpdatingTranscription(false);
        }
    };

    return (
        <>
            <div style={{ padding: isMobile ? '2%' : '', background: 'transparent', minHeight: '100vh' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0px', marginBottom: '8px' }}>
                    <p style={{ fontWeight: 'bold', fontSize: '32px', color: '#3b82f6', margin: 0, display: 'flex', alignItems: 'center' }}>My Clips</p>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: 2,
                            mb: 3,
                        }}
                    >
                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                            <Checkbox
                                checked={allClipsSelected}
                                indeterminate={someClipsSelected}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedClipIds(
                                            generatedBlogDetail.map((clip: any) => clip.campaign_id)
                                        );
                                    } else {
                                        setSelectedClipIds([]);
                                    }
                                }}
                            />

                            <Typography color="#fff">
                                {allClipsSelected ? "Unselect All" : "Select All"}
                            </Typography>

                            {/*<Button
                                variant="contained"
                                color="primary"
                                disabled={
                                    selectedClipIds.length === 0 ||
                                    isBulkPublishing
                                }
                                startIcon={
                                    isBulkPublishing ? (
                                    <CircularProgress
                                        size={18}
                                        sx={{ color: "white" }}
                                    />
                                    ) : null
                                }
                                onClick={handleBulkPublishClips}
                                >
                                {isBulkPublishing
                                    ? "Generating..."
                                    : `Generate Posts (${selectedClipIds.length})`}
                            </Button>*/}

                            <Button
                                variant="contained"
                                color="error"
                                disabled={selectedClipIds.length === 0}
                                onClick={() => setBulkDeleteModal(true)}
                            >
                                Delete Selected ({selectedClipIds.length})
                            </Button>
                            {/*<button
                                type="button"
                                className="button_leniar"
                                style={{ fontWeight: 'normal', fontSize: '14px', borderRadius: '26px', display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 18px' }}
                                onClick={() => { localStorage.setItem('activeItem', 'digital'); navigate('/codegenie/generated-blogs', { state: { activeItem: 'digital' } }); }}
                            >
                                <AddOutlinedIcon style={{ fontSize: '18px' }} />
                                Create Clips from Uploaded Videos
                            </button>*/}
                        </Box>
                    </Box>
                </div>
                <div className="row" style={{ display: 'flex', }}>
                    {isMobile ?
                        <>
                            <div className="col-12">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '15px' }}>
                                    <Autocomplete
                                        options={dropdownList}
                                        filterOptions={(options) => options}
                                        sx={{ "& label": { color: "#9ca3af" }, "& input": { className: 'red-border1' }, background: 'transparent', width: '100%' }}
                                        value={selectedBlogTitle || ''}
                                        onInputChange={handleClipsSearch}
                                        onChange={async (event, newValue) => {
                                            const nextValue = newValue || '';
                                            setSelectedBlogTitle(nextValue);
                                            setSearchQuery(nextValue);
                                            setCurrentPage(1);
                                            const trimmed = nextValue.trim();
                                            try {
                                                await fetchClipsData(pageSize, 0, trimmed, fromDate, toDate);
                                            } catch (error) {
                                                console.error("Clips fetch error:", error);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Search by clip title..."
                                                size="small"
                                                InputLabelProps={{
                                                    className: 'red-label'
                                                }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                    sx: {
                                                        border: 'none',
                                                        outline: 'none'
                                                    }
                                                }}
                                                sx={{
                                                    '& .MuiInputBase-input::placeholder': {
                                                        color: '#6b7280',
                                                        opacity: 1
                                                    },
                                                    '& .MuiInputBase-input': { color: '#ffffff' },
                                                    '& .MuiOutlinedInput-root': {
                                                        border: '1px solid #21262d',
                                                        borderRadius: '8px',
                                                        background: 'transparent',
                                                        '& fieldset': {
                                                            border: 'none',
                                                        }
                                                    },
                                                }
                                                }
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '2%' }}>
                                <div className="col-12">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                                            <DatePicker
                                                label="From Date"
                                                value={fromDate ? dayjs(fromDate) : null}
                                                onChange={(newVal) => {
                                                    setFromDate(newVal ? dayjs(newVal).format('YYYY-MM-DD') : null);
                                                }}
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiInputLabel-root': { color: '#3b82f6' },
                                                    '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
                                                    '& .MuiInputBase-input': { color: '#e5e7eb' },
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: '#161b22',
                                                        '& fieldset': { borderColor: '#30363d' },
                                                        '&:hover fieldset': { borderColor: '#3b82f6' },
                                                        '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                                                    },
                                                    '& .MuiSvgIcon-root': { color: '#3b82f6' },
                                                }}
                                            />

                                            {fromDate && (
                                                <IconButton onClick={() => { setFromDate(null); setCloseDateFilter(true); }} size="small">
                                                    <CloseIcon />
                                                </IconButton>
                                            )}
                                        </DemoContainer>
                                    </LocalizationProvider>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                                            <DatePicker
                                                label="To Date"
                                                value={toDate ? dayjs(toDate) : null}
                                                onChange={(newVal) => {
                                                    setToDate(newVal ? dayjs(newVal).format('YYYY-MM-DD') : null);
                                                }}
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiInputLabel-root': { color: '#3b82f6' },
                                                    '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
                                                    '& .MuiInputBase-input': { color: '#e5e7eb' },
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: '#161b22',
                                                        '& fieldset': { borderColor: '#30363d' },
                                                        '&:hover fieldset': { borderColor: '#3b82f6' },
                                                        '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                                                    },
                                                    '& .MuiSvgIcon-root': { color: '#3b82f6' },
                                                }}
                                            />
                                            {toDate && (
                                                <IconButton onClick={() => { setToDate(null); setCloseDateFilter(true); }} size="small">
                                                    <CloseIcon />
                                                </IconButton>
                                            )}
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '2%' }}>
                                <div className="col-12">
                                    {/*<button type="button" className="button_leniar" style={{ width: '100%' }}
                                        onClick={() => {
                                            const clearLocalStorage = () => {
                                                const keysToRemove = ["campaignid", "returningtocampaign", "sourceurl", "campaignName", "paymentOption",
                                                    "autoPublish", "limitPublish", "smUrlpublish", "addTags", "captureLeads", "newsLetter", "twitterBtn", "fbBtn", "pintrestBtn", "linkedinBtn",
                                                    "video", "twitterurl", "fburl", "pintresturl", "linkedinurl", "useOwnDomain", "ChangepayMode", "IdChangingMode", "Authorurl", "Authorname",
                                                    "authorDefaultCheck", "videoTag", "podcastUrl", "sourcetext"];
                                                keysToRemove.forEach(key => localStorage.removeItem(key));
                                            };
                                            if (userDets?.mode === 'Canceled') {
                                                setUpgradeModal(true);
                                                return;
                                            }
                                            if (planDetails?.subscription_level !== undefined || planDetails !== ''  || userDets.podcast_count_balance > 0) {
                                                localStorage.setItem('activeItem', 'createcontent');
                                                clearLocalStorage();
                                                navigate('/codegenie/generated-blogs');
                                            } else if (userDets?.podcast_count_balance === 0) {
                                                setUpgradeModal(true);
                                            } else {
                                                localStorage.setItem('fromUpgrade', 'true');
                                                localStorage.setItem('activeItem', 'upgrade');
                                                navigate('/codegenie/generated-blogs', { state: { 'campaignIdFromBL': localStorage.getItem('campId'), 'from_page': 'blog_listing', 'useremail': userEmail/* userDets?.email *//* } });
                                            }
                                        }}><AddOutlinedIcon />Create Content</button>*/}
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '2%' }}>
                                <div className="col-12" style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#9ca3af",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Total Clips: {getBlogsCount?.data ?? 0}
                                        </Typography>
                                        <Pagination
                                            count={Math.ceil((getBlogsCount?.data ?? 0) / pageSize)}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="primary"
                                            sx={{
                                                '& .MuiPaginationItem-root': {
                                                    backgroundColor: '#21262d',
                                                    color: '#9ca3af',
                                                    borderRadius: '4px',
                                                    padding: '0.4rem',
                                                    fontSize: '0.875rem',
                                                    margin: '0 0.2rem',
                                                },
                                                '& .Mui-selected': {
                                                    backgroundColor: '#3b82f6',
                                                    color: '#ffffff',
                                                    border: '1px solid #3b82f6'
                                                },
                                                '& .MuiPaginationItem-ellipsis': {
                                                    backgroundColor: 'transparent',
                                                    color: '#9ca3af',
                                                },
                                                '& .MuiPaginationItem-icon': {
                                                    color: '#6b7280',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                        : ''}

                    <div className="col-sm-12 col-md-9 col-lg-9" style={{ marginTop: '1%' }}>
                        {(generatedBlogDetail && generatedBlogDetail.length > 0) ?
                            (generatedBlogDetail && generatedBlogDetail.map((blog: any, index: any) => (
                                <React.Fragment key={blog._id || index}>
                                    <div style={{ display: isMobile ? 'block' : 'flex', gap: '20px', background: 'transparent', border: '1px solid #21262d', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "inline-block",
                                            }}
                                        >
                                            <figure className="box">
                                                <img src={`${/^(https?:)?\/\//i.test(blog.thumbnail)
                                                    ? blog.thumbnail
                                                    : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${blog.thumbnail?.startsWith("/") ? "" : "/"
                                                    }${blog.thumbnail}`
                                                    }?t=${timestampInSeconds}`}/* src={`${blog.thumbnail}?t=${timestampInSeconds}`} */ className="img" width={326} alt="thumbnail" />
                                            </figure>
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: 8,
                                                    left: 8,
                                                    zIndex: 10,
                                                    background: "rgba(0,0,0,0.7)",
                                                    borderRadius: "50%",
                                                }}
                                            >
                                                <Checkbox
                                                    checked={selectedClipIds.includes(blog.campaign_id)}
                                                    onChange={() => handleClipSelection(blog.campaign_id)}
                                                    sx={{
                                                        color: "#fff",
                                                        "&.Mui-checked": {
                                                            color: "#4BA5EB",
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        <div style={{ width: '100%' }}>
                                            <div className="row">
                                                <div className="col-sm-9 col-md-9 col-lg-9" style={{ marginTop: isMobile ? '2%' : '', cursor: 'pointer', background: 'transparent' }}>

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "flex-start",
                                                            gap: "8px",
                                                            marginTop: "8px",
                                                        }}
                                                    >
                                                        {editingTitleId === blog.campaign_id ? (
                                                            <>
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    multiline
                                                                    minRows={2.5}
                                                                    value={editedTitle}
                                                                    onChange={(e) => setEditedTitle(e.target.value)}
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-root": {
                                                                            color: "#fff",
                                                                        },
                                                                    }}
                                                                />

                                                                <Tooltip title="Update">
                                                                    <IconButton
                                                                        onClick={() => handleDescriptionUpdate(blog)}
                                                                        color="success"
                                                                    >
                                                                        {updatingTranscription ? <CircularProgress /> : <CheckIcon />}
                                                                    </IconButton>
                                                                </Tooltip>

                                                                <Tooltip title="Cancel">
                                                                    <IconButton
                                                                        color="error"
                                                                        onClick={() => {
                                                                            setEditingTitleId(null);
                                                                            setEditedTitle("");
                                                                        }}
                                                                    >
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#e5e7eb', maxWidth: isMobile ? '' : '35ch', overflowWrap: 'break-word', wordWrap: 'break-word', whiteSpace: 'normal' }}>{(blog.title ?? '').replace(/<\/?[^>]+(>|$)/g, '').replace(/\"/g, '').replace(/\*\*/g, '')}</p>

                                                                <Tooltip title="Edit Title">
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setEditingTitleId(blog.campaign_id);
                                                                            setEditedTitle(blog.title || "");
                                                                        }}
                                                                    >
                                                                        <EditOutlinedIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* ── ACTION ROW: View · Edit · Delete · Publish · SubMenu ── */}
                                                <div className="col-sm-3 col-md-3 col-lg-3" style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    gap: isMobile ? '4px' : '6px',
                                                    marginTop: isMobile ? '2%' : '',
                                                    alignItems: 'flex-start',
                                                    flexWrap: 'nowrap',
                                                    background: 'transparent',
                                                    flexShrink: 0,
                                                }}>
                                                    {/* View – opens video player */}
                                                    <Tooltip title="View Clip">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleVideoClick(blog.video_path)}
                                                            sx={{
                                                                color: '#9ca3af',
                                                                border: '1px solid #30363d',
                                                                borderRadius: '6px',
                                                                padding: isMobile ? '3px' : '4px',
                                                                '&:hover': {
                                                                    color: '#3b82f6',
                                                                    borderColor: '#3b82f6',
                                                                    backgroundColor: 'rgba(59,130,246,0.1)',
                                                                },
                                                            }}
                                                        >
                                                            <VisibilityOutlinedIcon sx={{ fontSize: isMobile ? '14px' : '16px' }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/*  {/* Edit – navigates to edit page *
    <Tooltip title="Edit Clip">
        <IconButton
            size="small"
            onClick={() => handleEditClick(blog)}
            sx={{
                color: '#9ca3af',
                border: '1px solid #30363d',
                borderRadius: '6px',
                padding: isMobile ? '3px' : '4px',
                '&:hover': {
                    color: '#3b82f6',
                    borderColor: '#3b82f6',
                    backgroundColor: 'rgba(59,130,246,0.1)',
                },
            }}
        >
            <EditOutlinedIcon sx={{ fontSize: isMobile ? '14px' : '16px' }} />
        </IconButton>
    </Tooltip>

    {/* Delete */}
                                                    <Tooltip title="Delete Clip">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleDeleteClick(blog.campaign_id)}
                                                            sx={{
                                                                color: '#9ca3af',
                                                                border: '1px solid #30363d',
                                                                borderRadius: '6px',
                                                                padding: isMobile ? '3px' : '4px',
                                                                '&:hover': {
                                                                    color: '#ef4444',
                                                                    borderColor: '#ef4444',
                                                                    backgroundColor: 'rgba(239,68,68,0.1)',
                                                                },
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon sx={{ fontSize: isMobile ? '14px' : '16px' }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* Publish / Generate Post */}
                                                    <Tooltip title="Publish">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handlePublishIconClick(blog)}
                                                            disabled={!!isPublishLoading[blog.campaign_id]}
                                                            sx={{
                                                                color: '#9ca3af',
                                                                border: '1px solid #30363d',
                                                                borderRadius: '6px',
                                                                padding: isMobile ? '3px' : '4px',
                                                                '&:hover': {
                                                                    color: '#10b981',
                                                                    borderColor: '#10b981',
                                                                    backgroundColor: 'rgba(16,185,129,0.1)',
                                                                },
                                                            }}
                                                        >
                                                            {isPublishLoading[blog.campaign_id] ? (
                                                                <CircularProgress size={isMobile ? 12 : 14} sx={{ color: '#3b82f6' }} />
                                                            ) : (
                                                                <PublishIcon sx={{ fontSize: isMobile ? '14px' : '16px' }} />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* 3-dots SubMenu */}
                                                    <SubMenuIcon
                                                        style={{ cursor: 'pointer', flexShrink: 0, width: isMobile ? '20px' : '24px', height: isMobile ? '20px' : '24px' }}
                                                        onClick={(e) => handleClick(e, blog.campaign_id, blog.product_id)}
                                                    />
                                                    <Menu
                                                        anchorEl={openMenuId === blog.campaign_id ? anchorEl : null}
                                                        open={openMenuId === blog.campaign_id}
                                                        onClose={() => setOpenMenuId(null)}
                                                        PaperProps={{
                                                            style: {
                                                                backgroundColor: '#36393F',
                                                                color: '#CACBCC',
                                                                borderRadius: '5px',
                                                                minWidth: '214px',
                                                                boxShadow: 'none',
                                                            },
                                                        }}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => { handleClose(); handleVideoClick(blog.video_path) }}>
                                                            <VideioIco fontSize="small" style={{ marginRight: '8px' }} />
                                                            Video/Audio
                                                        </MenuItem>
                                                        <MenuItem onClick={() => { handleTranscriptClick(blog.campaign_id, blog.transcript); }}>
                                                            {isLoadingTranscript[blog.campaign_id] ? (
                                                                <CircularProgress size={20} style={{ marginRight: '8px', color: '#CACBCC' }} />
                                                            ) : (
                                                                <MicIcon fontSize="small" style={{ marginRight: '8px' }} />
                                                            )}
                                                            Transcript
                                                        </MenuItem>
                                                        {/* <MenuItem onClick={(event) => {
                                                    handleExportClick(blogIdofsubmenu, blog.url, blog.product_id, blog.blog_title, blog.blog_summary, blog.blog_det, blog.blog_image_path);
                                                    setShareAnchorEl(event.currentTarget as HTMLElement);
                                                }}>
                                                    <ExportIco fontSize="small" style={{ marginRight: '8px' }} />
                                                    Share
                                                </MenuItem> */}
                                                    </Menu>

                                                    {/* Share platform sub-menu */}
                                                    <Menu
                                                        anchorEl={shareAnchorEl}
                                                        open={Boolean(shareAnchorEl)}
                                                        onClose={() => { setShareAnchorEl(null); }}
                                                        PaperProps={{ style: { backgroundColor: '#36393F', color: '#CACBCC', borderRadius: '5px', minWidth: '140px', boxShadow: 'none' } }}
                                                        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                                                        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
                                                    >
                                                        <MenuItem onClick={() => { setShareAnchorEl(null); window.open(`https://twitter.com/intent/tweet`, '_blank'); }}>
                                                            <TwitterIcon fontSize="small" style={{ marginRight: '8px' }} />
                                                            Twitter
                                                        </MenuItem>
                                                        <MenuItem onClick={() => { setShareAnchorEl(null); window.open(`https://www.facebook.com/sharer/sharer.php`, '_blank'); }}>
                                                            <FacebookIcon fontSize="small" style={{ marginRight: '8px' }} />
                                                            Facebook
                                                        </MenuItem>
                                                        <MenuItem onClick={() => { setShareAnchorEl(null); window.open(`https://www.linkedin.com/shareArticle`, '_blank'); }}>
                                                            <LinkedInIcon fontSize="small" style={{ marginRight: '8px' }} />
                                                            LinkedIn
                                                        </MenuItem>
                                                    </Menu>
                                                </div>
                                                {/* ── END ACTION ROW ── */}
                                            </div>
                                            <p style={{ fontSize: '12px', fontWeight: 'lighter', color: '#9ca3af' }}>{`Created on: ${new Date(blog.created_at).toLocaleString('en-US', {
                                                month: 'long',
                                                day: 'numeric',
                                                year: 'numeric',
                                                hour: 'numeric',
                                                minute: 'numeric',
                                                hour12: true,
                                            })}`}</p>
                                            {/* <p style={{ fontSize: '12px', fontWeight: 'lighter', color: '#9ca3af' }}>{`${blog.description}`}</p> */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    gap: "8px",
                                                    marginTop: "8px",
                                                }}
                                            >
                                                {editingDescriptionId === blog.campaign_id ? (
                                                    <>
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            multiline
                                                            minRows={2.5}
                                                            maxRows={6}
                                                            value={editedDescription}
                                                            onChange={(e) => setEditedDescription(e.target.value)}
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    color: "#fff",
                                                                },
                                                            }}
                                                        />

                                                        <Tooltip title="Update">
                                                            <IconButton
                                                                onClick={() => handleDescriptionUpdate(blog)}
                                                                color="success"
                                                            >
                                                                {updatingTranscription ? <CircularProgress /> : <CheckIcon />}
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Tooltip title="Cancel">
                                                            <IconButton
                                                                color="error"
                                                                onClick={() => {
                                                                    setEditingDescriptionId(null);
                                                                    setEditedDescription("");
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                ) : (
                                                    <>
                                                        <p
                                                            style={{
                                                                fontSize: "12px",
                                                                fontWeight: "lighter",
                                                                color: "#9ca3af",
                                                                flex: 1,
                                                                margin: 0,
                                                                overflow: "hidden",

                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: "vertical",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                            }}
                                                        >
                                                            {blog.transcript}
                                                        </p>

                                                        <Tooltip title="Edit Description">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setEditingDescriptionId(blog.campaign_id);
                                                                    setEditedDescription(blog.transcript || "");
                                                                }}
                                                            >
                                                                <EditOutlinedIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {index !== generatedBlogDetail.length - 1 && (
                                        <hr style={{ borderColor: '#e5e5e5', margin: '20px 0', width: '100%' }} />
                                    )}
                                </React.Fragment>
                            ))) :
                            <div>
                                {generatedBlogDetail && generatedBlogDetail.length === 0 ?
                                    <div className="alert alert-info" role="alert">
                                        {((localStorage.getItem('DirectSignup') === 'true' || localStorage.getItem('appsumo_coupon_code')) && (planDetails?.plan_name === 'Free' || planDetails?.plan_name === 'Life Time' || planDetails?.plan_name === '' || !planDetails?.plan_name) || !planDetails?.plan_name) || selectedDate ? 'No blogs generated.' : 'No records found.'}
                                    </div>
                                    :
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <CircularProgress size={50} color="primary" />
                                    </div>
                                }
                            </div>}

                        {!isMobile && generatedBlogDetail?.length > 0 ?
                            <Stack spacing={2} style={{ marginTop: '1rem', marginBottom: '1rem', alignItems: 'center' }}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#9ca3af",
                                            fontSize: "14px",
                                        }}
                                    >
                                        Total Clips: {getBlogsCount?.data ?? 0}
                                    </Typography>

                                    <Pagination
                                        count={Math.ceil((getBlogsCount?.data ?? 0) / pageSize)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                        sx={{
                                            '& .MuiPaginationItem-root': {
                                                backgroundColor: '#21262d',
                                                color: '#9ca3af',
                                                borderRadius: '4px',
                                                padding: '0.4rem',
                                                fontSize: '0.875rem',
                                                margin: '0 0.2rem',
                                            },
                                            '& .Mui-selected': {
                                                backgroundColor: '#3b82f6',
                                                color: '#ffffff',
                                                border: '1px solid #3b82f6'
                                            },
                                            '& .MuiPaginationItem-ellipsis': {
                                                backgroundColor: 'transparent',
                                                color: '#9ca3af',
                                            },
                                            '& .MuiPaginationItem-icon': {
                                                color: '#6b7280',
                                            },
                                        }}
                                    />
                                </div>
                            </Stack> : ''}
                    </div>
                    {!isMobile ? <div className="col-3">
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '15px', marginTop: '3%', background: 'transparent', borderRadius: '14px', border: '1px solid #21262d', padding: '20px' }}>
                            <Autocomplete
                                options={dropdownList}
                                filterOptions={(options) => options}
                                sx={{ "& label": { color: "#9ca3af" }, "& input": { className: 'red-border1' }, background: 'transparent', width: '100%' }}
                                value={selectedBlogTitle || ''}
                                onInputChange={handleClipsSearch}
                                onChange={async (event, newValue) => {
                                    const nextValue = newValue || '';
                                    setSelectedBlogTitle(nextValue);
                                    setSearchQuery(nextValue);
                                    setCurrentPage(1);
                                    const trimmed = nextValue.trim();
                                    try {
                                        await fetchClipsData(pageSize, 0, trimmed, fromDate, toDate);
                                    } catch (error) {
                                        console.error("Clips fetch error:", error);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Search by clip title..."
                                        size="small"
                                        InputLabelProps={{
                                            className: 'red-label'
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            sx: {
                                                border: 'none',
                                                outline: 'none'
                                            }
                                        }}
                                        sx={{
                                            '& .MuiInputBase-input::placeholder': {
                                                color: '#6b7280',
                                                opacity: 1
                                            },
                                            '& .MuiInputBase-input': { color: '#e5e7eb' },
                                            '& .MuiOutlinedInput-root': {
                                                border: '1px solid #e5e5e5',
                                                borderRadius: '8px',
                                                background: 'transparent',
                                                '& fieldset': {
                                                    border: 'none',
                                                }
                                            },
                                        }
                                        }
                                    />
                                )}
                            />
                            <Typography sx={{ width: '100%', color: '#9ca3af', fontSize: '13px', fontWeight: 500 }}>Filter By Date Range</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate ? dayjs(fromDate) : null}
                                        onChange={(newVal) => {
                                            setFromDate(newVal ? dayjs(newVal).format('YYYY-MM-DD') : null);
                                        }}
                                        sx={{
                                            width: '100%',
                                            '& .MuiInputLabel-root': { color: '#3b82f6' },
                                            '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
                                            '& .MuiInputBase-input': { color: '#e5e7eb' },
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: '#161b22',
                                                '& fieldset': { borderColor: '#30363d' },
                                                '&:hover fieldset': { borderColor: '#3b82f6' },
                                                '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                                            },
                                            '& .MuiSvgIcon-root': { color: '#3b82f6' },
                                        }}
                                    />

                                    {fromDate && (
                                        <IconButton onClick={() => { setFromDate(null); setCloseDateFilter(true); }} size="small">
                                            <CloseIcon />
                                        </IconButton>
                                    )}
                                </DemoContainer>
                            </LocalizationProvider>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate ? dayjs(toDate) : null}
                                        onChange={(newVal) => {
                                            setToDate(newVal ? dayjs(newVal).format('YYYY-MM-DD') : null);
                                        }}
                                        sx={{
                                            width: '100%',
                                            '& .MuiInputLabel-root': { color: '#3b82f6' },
                                            '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
                                            '& .MuiInputBase-input': { color: '#e5e7eb' },
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: '#161b22',
                                                '& fieldset': { borderColor: '#30363d' },
                                                '&:hover fieldset': { borderColor: '#3b82f6' },
                                                '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                                            },
                                            '& .MuiSvgIcon-root': { color: '#3b82f6' },
                                        }}
                                    />
                                    {toDate && (
                                        <IconButton onClick={() => { setToDate(null); setCloseDateFilter(true); }} size="small">
                                            <CloseIcon />
                                        </IconButton>
                                    )}
                                </DemoContainer>
                            </LocalizationProvider>
                            {/* <button className="button_leniar" style={{ width: '100%', borderRadius: '25px', alignSelf: 'flex-start' }}
                                onClick={() => {
                                    const clearLocalStorage = () => {
                                        const keysToRemove = ["campaignid", "returningtocampaign", "sourceurl", "campaignName", "paymentOption",
                                            "autoPublish", "limitPublish", "smUrlpublish", "addTags", "captureLeads", "newsLetter", "twitterBtn", "fbBtn", "pintrestBtn", "linkedinBtn",
                                            "video", "twitterurl", "fburl", "pintresturl", "linkedinurl", "useOwnDomain", "ChangepayMode", "IdChangingMode", "Authorurl", "Authorname",
                                            "authorDefaultCheck", "videoTag", "podcastUrl", "sourcetext"];
                                        keysToRemove.forEach(key => localStorage.removeItem(key));
                                    };
                                    if (userDets?.mode === 'Canceled') {
                                        setUpgradeModal(true);
                                        return;
                                    }
                                    if (planDetails?.subscription_level !== undefined || planDetails !== '' || userDets.podcast_count_balance > 0 ) {
                                        localStorage.setItem('activeItem', 'createcontent');
                                        navigate('/codegenie/generated-blogs');
                                        setTimeout(()=>{
                                            window.location.reload();
                                        },100);
                                        clearLocalStorage();
                                    } else if (userDets?.podcast_count_balance === 0) {
                                        setUpgradeModal(true);
                                    } else {
                                          localStorage.setItem('fromUpgrade', 'true');
                                        localStorage.setItem('activeItem', 'upgrade');
                                        setTimeout(()=>{
                                            window.location.reload();
                                        },100);
                                        navigate('/codegenie/generated-blogs', { state: { 'campaignIdFromBL': localStorage.getItem('campId'), 'from_page': 'blog_listing', 'useremail': userEmail } });
                                    }
                                }}><AddOutlinedIcon />Create Social Content</button> */}
                        </div>
                    </div> : ''}
                </div>
            </div>


            {/* Publish Success Modal */}
            <Modal open={publishSuccessModal} onClose={() => setPublishSuccessModal(false)}
                aria-labelledby="publish-success-modal">
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '380px', bgcolor: '#1a1a2e',
                    borderRadius: '12px', boxShadow: '0px 8px 32px rgba(0,0,0,0.5)',
                    p: 4, '&:focus': { outline: 'none' }, textAlign: 'center',
                }}>
                    <TaskAltIcon sx={{ color: '#10b981', fontSize: 44, mb: 1 }} />
                    <Typography sx={{ color: '#fff', fontWeight: 700, mb: 1, fontSize: '16px' }}>
                        Post generated & queued for publishing
                    </Typography>
                    <Typography sx={{ color: '#aaa', fontSize: '13px', mb: 3 }}>
                        Your post has been created successfully. You can view it in your content list.
                    </Typography>
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <Button variant="outlined" sx={{ color: '#aaa', borderColor: '#555', textTransform: 'none' }}
                            onClick={() => setPublishSuccessModal(false)}>
                            Close
                        </Button>
                        <Button variant="contained"
                            sx={{ background: 'linear-gradient(90deg,#2563eb,#1d9bf0)', textTransform: 'none', fontWeight: 600 }}
                            onClick={() => {
                                localStorage.setItem('activeItem', 'authority');
                                setTimeout(() => { window.location.reload(); }, 100);
                            }}>
                            Go to Content List
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            {/* popups */}
            <Modal
                open={openUnsplash}
                onClose={() => setOpenUnsplash(false)}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "90%" : "54%",
                        bgcolor: "background.paper",
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 1.2)',
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '10px',
                        overflowY: isMobile ? 'auto' : 'hidden',
                        height: isMobile ? '600px' : '650px',
                        maxHeight: '650px'
                    }}
                >
                    <div className="row" style={{ width: '100%', marginTop: '5%' }}>
                        <div className=" col-sm-12 col-md-10 col-lg-10">
                            <TextField
                                placeholder="Search Unsplash images"
                                size="small"
                                InputLabelProps={{
                                    className: 'red-label'
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    '& .MuiInputBase-input::placeholder': {
                                        color: 'white',
                                        opacity: 1
                                    },
                                    width: '100%'
                                }}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-12 col-md-2 col-lg-2" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Button variant="contained" onClick={handleSearch} sx={{ fontWeight: 'bold', width: isMobile ? '100%' : '' }}>Search</Button>
                        </div>
                    </div>
                    {unsplashSearch === false ?
                        <div className="row" style={{ width: '100%' }}>
                            <div className="col-md-12">
                                <img src={unsplash_logo} style={{ width: '10%', display: 'block', margin: '0 auto', marginTop: '17%' }} alt="unsplash logo" />
                                <Typography variant="h4" sx={{ marginTop: '1%', textAlign: 'center' }}>Unsplash</Typography>
                                <Typography variant="h6" sx={{ marginTop: '1%', textAlign: 'center' }}>Try entering a search term, such as apple or daisy, to explore beautiful, high-resolution visuals.</Typography>

                                <Typography variant="h6" sx={{ textAlign: 'center' }}>Once you've found an image you're happy with, click on it to add it to your workspace.</Typography>
                                <Typography variant="h6" sx={{ textAlign: 'center' }} onClick={() => window.open('https://unsplash.com/', '_blank')}><a href="#" style={{ textDecoration: 'none' }}>unsplash.com</a></Typography>
                            </div>
                        </div>
                        :
                        <div className="row" style={{ marginTop: '6%' }}>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
                                gap: '10px',
                                justifyContent: 'center'
                            }}>
                                {horizontalImages.map((image) => (
                                    <div key={image.id} className="thumbnail-container">
                                        <img
                                            className="thumbnail"
                                            src={modifyImageUrl(image.urls.thumb)}
                                            alt={image.alt_description}
                                            style={{ width: '100px', cursor: 'pointer', border: image.id === selectedUnsplashImg ? '3px solid #4BA5EB' : '' }}
                                            onClick={() => handleSelectUnsplashImage(image.urls.regular, image.id)}
                                        />
                                        <img
                                            className="full-image"
                                            src={image.urls.regular}
                                            alt={image.alt_description}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }

                    <div className="row" style={{ marginTop: '5%' }}>
                        <div className={isMobile ? "col-6" : "col-sm-6 col-md-6 col-lg-6"}>
                            <Button variant="contained" sx={{ fontWeight: 'bold' }} onClick={handleUnsplashselectionChange}>Select</Button>
                        </div>
                        <div className={isMobile ? "col-6" : "col-sm-6 col-md-6 col-lg-6"}>
                            <Button variant="contained" sx={{ fontWeight: 'bold' }} onClick={() => setOpenUnsplash(false)}>Close</Button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={openExportModal}
                onClose={() => setOpenExportModal(false)}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "90%" : "30%",
                        bgcolor: "#000000",
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 1.2)',
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '5px',
                        overflowY: 'auto',
                        height: isMobile ? '600px' : '650px',
                        maxHeight: '650px',
                        paddingTop: 'none',
                        paddingLeft: 'none',
                        paddingRight: 'none',
                        padding: '1%',
                        '&:focus': { outline: 'none' },
                    }}
                >
                    <div className="row" style={{ width: '100%', paddingTop: '1%', paddingBottom: '1%', backgroundColor: '#4BA5EB', alignItems: 'center' }}>
                        <div className="col-2">
                            <CloseIcon style={{ color: '#fff', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => setOpenExportModal(false)} />
                        </div>
                        <div className="col-10" style={{ paddingTop: '2%' }}>
                            <h6 style={{ color: '#fff', fontWeight: 'bold' }}>Export</h6>
                        </div>
                    </div>

                    {planDetails?.instant_indexing_with_google == 1 ?
                        <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                            <div className="col-6">
                                <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>Publish to Google</Typography>
                            </div>
                            <div className="col-3" style={{ textAlign: 'center' }}>
                                <PlayBtn style={{ cursor: 'pointer' }} />
                            </div>
                            <div className="col-3" style={{ textAlign: 'center' }}>
                                {isLoadingCopied[blogIdForExport] ? <CircularProgress size={24} /> : <ShareOutlinedIcon style={{ border: '1px solid #4BA5EB', borderRadius: '3px', padding: '1%', color: '#4BA5EB', cursor: 'pointer' }} onClick={() => handelShareClick(blogIdForExport, 0, 0)} />}
                            </div>
                        </div>
                        : ''}

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-12">
                            <Typography>Download</Typography>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <ClipboardIcon sx={{ color: '#fff' }} />
                        </div>
                        <div className="col-8">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>{'Copy to clipboard'}</Typography>
                        </div>
                        <div className="col-2">
                            {isDownloadLoading == 'clipboard1' ? <CircularProgress size={24} /> : <Typography sx={{ color: '#4BA5EB', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => handleDownloadFileClick('clipboard1')}>Copy</Typography>}
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <CodeIcon sx={{ color: '#fff' }} />
                        </div>
                        <div className="col-8">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>HTML</Typography>
                        </div>
                        <div className="col-2">
                            {isDownloadLoading == 'html' ? <CircularProgress size={24} /> : <Typography sx={{ color: '#4BA5EB', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => handleDownloadFileClick('html')}>Copy</Typography>}
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <TextFieldsIcon sx={{ color: '#fff' }} />
                        </div>
                        <div className="col-8">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>{'Text(Markdown)'}</Typography>
                        </div>
                        <div className="col-2">
                            {isDownloadLoading == 'txt' ? <CircularProgress size={24} /> : <Typography sx={{ color: '#4BA5EB', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => handleDownloadFileClick('txt')}>Copy</Typography>}
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <WordIcon style={{ color: '#fff' }} />
                        </div>
                        <div className="col-8">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>{'Word(docx)'}</Typography>
                        </div>
                        <div className="col-2" style={{ justifyContent: 'center', display: 'flex' }}>
                            {isDownloadLoading == 'docx' ? <CircularProgress size={24} /> : <FileDownloadIcon sx={{ color: '#4BA5EB', cursor: 'pointer' }} onClick={() => handleDownloadFileClick('docx')} />}
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <PictureAsPdfIcon style={{ color: '#fff' }} />
                        </div>
                        <div className="col-8">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>PDF</Typography>
                        </div>
                        <div className="col-2" style={{ justifyContent: 'center', display: 'flex' }}>
                            {isDownloadLoading == 'pdf' ? <CircularProgress size={24} /> : <FileDownloadIcon sx={{ color: '#4BA5EB', cursor: 'pointer' }} onClick={() => handleDownloadFileClick('pdf')} />}
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-12">
                            <Typography>Share</Typography>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <TwitterIcon style={{ color: '#fff' }} />
                        </div>
                        <div className="col-4">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>Twitter</Typography>
                        </div>
                        <div className="col-2" onClick={() => handlePlayVideo('/images/twitter.mp4')} style={{ textAlign: 'center' }}>
                            <PlayBtn style={{ cursor: 'pointer' }} />
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            {isLoadingEditPost === 'twitter' ? <CircularProgress size={24} /> : <AutoAwesomeOutlinedIcon style={{ border: '1px solid #4BA5EB', borderRadius: '3px', padding: '1%', color: '#4BA5EB', cursor: 'pointer' }} onClick={() => handlemagicIcoClick('twitter')} />}
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <FacebookIcon style={{ color: '#fff' }} />
                        </div>
                        <div className="col-4">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>Facebook</Typography>
                        </div>
                        <div className="col-2" onClick={() => handlePlayVideo('/images/facebook.mp4')} style={{ textAlign: 'center' }}>
                            <PlayBtn style={{ cursor: 'pointer' }} />
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            {isLoadingEditPost === 'facebook' ? <CircularProgress size={24} /> : <AutoAwesomeOutlinedIcon style={{ border: '1px solid #4BA5EB', borderRadius: '3px', padding: '1%', color: '#4BA5EB', cursor: 'pointer' }} onClick={() => handlemagicIcoClick('facebook')} />}
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <LinkedInIcon style={{ color: '#fff' }} />
                        </div>
                        <div className="col-4">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>LinkedIn</Typography>
                        </div>
                        <div className="col-2" onClick={() => handlePlayVideo('/images/linkedin.mp4')} style={{ textAlign: 'center' }}>
                            <PlayBtn style={{ cursor: 'pointer' }} />
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            {isLoadingEditPost === 'linkedin' ? <CircularProgress size={24} /> : <AutoAwesomeOutlinedIcon style={{ border: '1px solid #4BA5EB', borderRadius: '3px', padding: '1%', color: '#4BA5EB', cursor: 'pointer' }} onClick={() => handlemagicIcoClick('linkedin')} />}
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-12">
                            <Typography>Export</Typography>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <WPLogoBlue />
                        </div>
                        <div className="col-6">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>
                                WordPress.org
                            </Typography>
                        </div>
                        <div className="col-2" style={{ display: 'flex', justifyContent: 'center' }}>
                            &nbsp;
                        </div>
                        <div className="col-2" style={{ display: 'flex', justifyContent: 'center' }}>
                            <Tooltip title="Publish to your WordPress Blog Site.">
                                <WPconfigIcon onClick={() => setWordpressModal(true)} style={{ cursor: 'pointer' }} />
                            </Tooltip>
                        </div>
                    </div>

                    <div className="row" style={{ width: '100%', paddingTop: '3%', paddingBottom: '1%', alignItems: 'center' }}>
                        <div className="col-2">
                            <WPLogoBlue />
                        </div>
                        <div className="col-6">
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>
                                WordPress.com
                            </Typography>
                        </div>
                        <div className="col-2" style={{ display: 'flex', justifyContent: 'center' }}>
                            &nbsp;
                        </div>
                        <div className="col-2" style={{ display: 'flex', justifyContent: 'center' }}>
                            {loadingBlog ? <CircularProgress size={24} /> :
                                <Tooltip title="Publish to Wordpress.com.">
                                    <PublishIcon onClick={handlePostToWordPress} style={{ cursor: 'pointer' }} />
                                </Tooltip>
                            }
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={helperPopup}
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "70%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    <iframe
                        width="100%"
                        height="500"
                        src={helpervideosrc}
                        title="Help Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                    <Stack flexDirection="row">
                        <Button
                            onClick={() => setHelperPopup(false)}
                            variant="contained"
                            sx={{ mr: 2, marginTop: '15%' }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={openPostEdit}
                onClose={() => setOPenEdit(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 1000,
                    bgcolor: "#131825",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    maxHeight: '110vh',
                    overflow: 'auto'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={8}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Edit Post Content</Typography>
                            </Grid>
                            <Grid item xs={12} lg={4} style={{ gap: '10px', display: 'flex' }}>
                                <Button variant="contained" style={{ textAlign: 'right', width: '50%' }} onClick={() => {
                                    const contentToCopy = `${sharingpostdata}`;
                                    navigator.clipboard.writeText(contentToCopy).then(() => {
                                        toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                                            style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
                                        });
                                    }).catch((error) => {
                                        console.log('error copying edited content!', error);
                                    })
                                }}><ContentCopyIcon /> Copy</Button>
                                <Button variant="contained" style={{ textAlign: 'right', width: '50%' }} onClick={() => setOpenPostEdit(false)}>Close</Button>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />

                        <Grid container>
                            <Grid item xs={12} lg={12} style={{ padding: '1%' }}>
                                <Stack padding="1%">
                                    <Typography style={{ color: '#fff' }}>Poster Content</Typography>
                                    <TextareaAutosize style={{ background: 'transparent', border: '1px solid #CBCBCB', width: '100%', borderRadius: '3px', height: '278px', overflow: 'auto', color: '#fff' }}
                                        value={sharingpostdata}
                                        onChange={(e) => {
                                            const updatedblogsummary = e.target.value;
                                            setSharingPostData(updatedblogsummary); localStorage.setItem('editedpostblogsummary', updatedblogsummary);
                                        }} />
                                </Stack>
                            </Grid>
                        </Grid>

                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={deteleModal}
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "40%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        <InfoIcon sx={{ color: '#ffcc00' }} />
                        <br />
                        Are you sure, you want to delete this clip and its related images?
                        This action cannot be undone.
                    </Typography>

                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>
                        <Button variant="contained" onClick={() => handleDelete(deleteBlogId)}>Yes</Button>
                        <Button onClick={() => setDeleteModal(false)} variant="contained">No</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={upgradeModal}
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "60%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "55%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    <Typography style={{ textAlign: 'center' }}><InfoIcon sx={{ color: '#ffcc00' }} /><br />{toUpgrade === true ? (<>
                        <span style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>FREE TRIAL</span>
                        <br />
                        We have created your <strong>personalized, SEO, FREE blogs</strong> from your content.  You can create 1 more blog with the Free Trial
                        <br /><br />
                        You can edit these blogs and export them to social media platforms, blogging sites, or download them.
                        <br /><br />
                        <span style={{ fontWeight: 'bold' }}>Next:</span> To start using the blogs, please complete registration by selecting a plan. Each plan includes a <strong>14-day free trial</strong> during which you will <strong>NOT</strong> be billed. You can cancel at any time. If you cancel before the end of the 14-day free period, you will not be charged.

                    </>) : 'This feature is not included in your plan.  Please upgrade to have access to this feature.'}</Typography>

                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                const value = {
                                    _id: "",
                                    product_name: "CodeGenie",
                                    product_module: genieSelector.module ? genieSelector.module : "",
                                    userid: "",
                                    productid: ""
                                };
                                getProduct(value);
                                localStorage.setItem('fromUpgrade', 'true');
                                navigate('/pricing', { state: { campIdFromUpgrade: selectedCampaign, from_page: 'pricing', fromNonSubscribed: 'true' } });
                            }}>
                            {toUpgrade === true ? 'Continue' : 'Upgrade'}
                        </Button>

                        {toUpgrade === true ? '' : <Button onClick={() => setUpgradeModal(false)} variant="contained">Close</Button>}
                    </Stack>
                </Box>
            </Modal>

            <Modal open={transcriptModal}
                onClose={() => setTranscriptModal(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 1000,
                    bgcolor: "#131825",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    maxHeight: '100vh',
                    overflow: 'auto'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12} style={{ padding: '2%' }}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Transcript</Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />

                        <Grid container>
                            <Grid item xs={12} lg={12} style={{ padding: '1%' }}>
                                <Stack padding="1%">
                                    <TextareaAutosize
                                        style={{
                                            width: '100%',
                                            borderRadius: '7px',
                                            backgroundColor: 'transparent',
                                            color: '#fff',
                                            textAlign: 'justify',
                                            height: '172px',
                                            overflow: 'auto',
                                        }}
                                        value={transcribedData ? transcribedData : 'No Transcribed Text Available'}
                                        placeholder="No Transcribed Text Available"
                                        readOnly
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} lg={12} style={{ padding: '1%', gap: '10px', display: 'flex' }}>
                                <Button variant="contained" onClick={handleCopyTranscriptClick}>Copy</Button>
                                <Button onClick={() => { setTranscriptModal(false); setTranscribedData(""); }} variant="contained">Close</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={mediaModal}
                onClose={() => setMediaModal(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: 1000,
                        bgcolor: "#131825",
                        border: "none",
                        pt: 2,
                        px: 4,
                        pb: 3,
                        maxHeight: "100vh",
                        overflow: "auto",
                    }}
                >
                    <Stack width="100%">
                        {mediaUrl && (
                            <Grid container justifyContent="center" sx={{ mb: 2 }}>
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    {mediaType === "video" ? (
                                        <video
                                            src={mediaUrl}
                                            controls
                                            autoPlay
                                            playsInline
                                            style={{
                                                width: "100%",
                                                maxWidth: "900px",
                                                borderRadius: "8px",
                                                backgroundColor: "#000",
                                            }}
                                        />
                                    ) : (
                                        <audio
                                            src={mediaUrl}
                                            controls
                                            autoPlay
                                            style={{
                                                width: "100%",
                                                maxWidth: "600px",
                                                marginTop: "10px",
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        )}

                        <Grid container>
                            <Grid item xs={12} sx={{ p: 1, gap: "10px", display: "flex", justifyContent: "flex-start" }}>
                                <Button onClick={() => { setMediaModal(false); }} variant="contained">Close</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={publishBlogModal}
                onClose={() => setPublishBlogModal(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 1000,
                    bgcolor: "#36393F",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    maxHeight: '110vh',
                    overflow: 'auto',
                    borderRadius: '8px',
                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Publish To</Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />

                        <Grid container>
                            <Grid item xs={12} lg={12} style={{ padding: '1%' }}>
                                <Stack padding="1%">
                                    <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={publishToOcesha}
                                                    onChange={handlePublishToOceshaChange}
                                                    style={{ color: '#fff', borderColor: '#fff' }}
                                                />
                                            }
                                            label=""
                                        />
                                        <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>Ocesha Server</span>
                                    </span>
                                </Stack>

                                <Stack padding="1%">
                                    <span style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={publishToCodegenie}
                                                    onChange={handlePublishToCodegenieChange}
                                                    style={{ color: '#fff', borderColor: '#fff' }}
                                                />
                                            }
                                            label=""
                                        />
                                        <span style={{ fontSize: '16px', display: 'block', fontWeight: 'bold' }}>Code Genie Server</span>
                                    </span>
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} lg={12} style={{ padding: '1%', gap: '10px', display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => PublishToServer(blogIdToPublish, publishToOcesha ? 1 : 0, publishToCodegenie ? 1 : 0)} variant="contained">
                                    {isLoadingCopied[blogIdToPublish] ? <CircularProgress size={24} /> : 'Publish'}
                                </Button>
                                <Button onClick={() => setPublishBlogModal(false)} variant="contained">Close</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={wordpressModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 1000,
                    bgcolor: "#131825",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    maxHeight: '110vh',
                    overflow: 'auto'
                }}>
                    <div style={{ color: '#fff' }}>
                        <Typography variant="h6">Post to Your WordPress Site</Typography>
                        <TextField
                            label="WordPress Site URL"
                            fullWidth
                            variant="outlined"
                            value={wpUrl}
                            onChange={(e) => setWpUrl(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            label="WordPress Username"
                            fullWidth
                            variant="outlined"
                            value={wpUsername}
                            onChange={(e) => setWpUsername(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            label="Application Password"
                            fullWidth
                            variant="outlined"
                            type="password"
                            value={wpPassword}
                            onChange={(e) => setWpPassword(e.target.value)}
                            margin="normal"
                        />
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handlePostwordpressorg}
                                disabled={wploading}
                                style={{ marginTop: '1rem' }}
                            >
                                {wploading ? 'Posting...' : 'Post to WordPress org'}
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => { setWordpressModal(false); setWpPassword(''); setWpUsername(''); setWpUrl(''); }}
                                style={{ marginTop: '1rem' }}
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
            <Modal
                open={bulkDeleteModal}
                onClose={() => setBulkDeleteModal(false)}
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "40%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    <Typography variant="h6" mb={2}>
                        Delete Clips
                    </Typography>

                    <Typography mb={3}>
                        Are you sure you want to delete
                        <strong> {selectedClipIds.length} </strong>
                        selected clip(s)? and its related images.
                        This action cannot be undone.
                    </Typography>

                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                        <Button
                            variant="outlined"
                            onClick={() => setBulkDeleteModal(false)}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            onClick={async () => {
                                await handleDeleteSelectedClips();
                                setBulkDeleteModal(false);
                            }}
                        >
                            Delete Selected
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </>
    )
}

export default Clips_Section;